<template>
  <div>
    <CRow class="mb-3">
      <div class="col-lg-3 col-md-6 col-sm-6">
        <label class="typo__label font-weight-bold"> Partner </label>
        <multiselect
          v-model="partnerSelected"
          placeholder="Seleccione un Partner"
          label="value"
          track-by="id"
          :options="partners"
          :close-on-select="true"
          :clear-on-select="false"
          :multiple="false"
          :taggable="false"
        ></multiselect>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <label class="typo__label font-weight-bold"> Location</label>
        <treeselect
          v-if="!isLoading"
          v-model="locationSelected"
          :multiple="true"
          :options="locations1[0]"
          @input="getfilterlocationName()"
        />
      </div>

      <CCol class="col-lg-3 col-md-6 col-sm-6">
        <label class="typo__label font-weight-bold"> Star Rating </label>

        <multiselect
          v-model="starratingSelected"
          placeholder="Seleccione un Rating"
          label="label"
          track-by="label"
          :options="starRating_unique1"
          @input="getfilterstarRating()"
          :multiple="true"
          :taggable="true"
        ></multiselect>
      </CCol>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div>
          <label class="typo__label font-weight-bold"> Date Created </label>
        </div>
        <date-picker
          v-model="range"
          range
          :shortcuts="shortcuts"
          confirm
          @change="dateSelected(range)"
        ></date-picker>
      </div>
    </CRow>
    <CRow class="pt-2 pb-3">
      <CCol sm="3"> </CCol>
    </CRow>

    <!-- <CRow>
      <div class="col-md-12">
        <CCard>
          <CCardBody>
            <div v-if="loader_starcommentreview">
              <semipolar-spinner
                :animation-duration="2000"
                :size="80"
                color="blue"
              ></semipolar-spinner>
            </div>

            <div v-else class="barChart">
              <highcharts
                class="chart"
                :options="barChartLeftOptionsSpline"
              ></highcharts>
            </div>
          </CCardBody>
        </CCard>
      </div>
    </CRow> -->

    <!-- New Widget Starts -->
    <CRow>
      <div class="col-md-12">
        <div class="_widget-div">
          <div class="_widget-item">
            <div class="_item-wrapper">
              <h5 class="text-center fw-600">Monthly Rating</h5>
              <hr width="1" />
              <p class="text-center">
                <b>{{ widget_month_rating }}</b>
              </p>
              <h6 class="text-center">graph shows Monthly Rating</h6>
              <p class="text-center">
                <i
                  v-if="widget_prev_month_rating < 0"
                  class="cil-arrow-bottom"
                ></i>
                <i
                  v-if="widget_prev_month_rating > 0"
                  class="cil-arrow-top"
                ></i>
                <i>{{ widget_prev_month_rating }}%</i>
              </p>
            </div>
          </div>
          <div class="_widget-item">
            <div class="_item-wrapper">
              <h5 class="text-center fw-600">Avg Rating</h5>
              <hr width="1" />
              <p class="text-center">
                <b>{{ widget_rating }}</b>
              </p>
              <h6 class="text-center">graph shows last 7 days avg rating</h6>
              <p class="text-center">
                <i v-if="widget_rating_per < 0" class="cil-arrow-bottom"></i>
                <i v-if="widget_rating_per > 0" class="cil-arrow-top"></i>
                <i>{{ widget_rating_per }}%</i>
              </p>
            </div>
          </div>
          <div class="_widget-item">
            <div class="_item-wrapper">
              <h5 class="text-center fw-600">Reviews</h5>
              <hr width="1" />
              <p class="text-center">
                <b>{{ widget_review }}</b>
              </p>
              <h6 class="text-center">graph shows last 7 days avg reviews</h6>
              <p class="text-center">
                <i v-if="widget_review_per < 0" class="cil-arrow-bottom"></i>
                <i v-if="widget_review_per > 0" class="cil-arrow-top"></i>
                <i>{{ widget_review_per }}%</i>
              </p>
            </div>
          </div>
          <div class="_widget-item">
            <div class="_item-wrapper">
              <h5 class="text-center fw-600">Comments</h5>
              <hr width="1" />
              <p class="text-center">
                <b>{{ widget_comment }}</b>
              </p>
              <h6 class="text-center">graph shows last 7 days avg comments</h6>
              <p class="text-center">
                <i v-if="widget_comment_per < 0" class="cil-arrow-bottom"></i>
                <i v-if="widget_comment_per > 0" class="cil-arrow-top"></i>
                <i>{{ widget_comment_per }}%</i>
              </p>
            </div>
          </div>
          <div class="_widget-item">
            <div class="_item-wrapper">
              <h5 class="text-center fw-600">Participation</h5>
              <hr width="1" />
              <p class="text-center">
                <i>{{ widget_perception_per }}%</i>
              </p>
            </div>
          </div>
          <div class="_widget-item">
            <div class="_item-wrapper">
              <h5 class="text-center fw-600">Active</h5>
              <hr width="1" />
              <h6 class="text-center">
                <b>Reviews</b>
              </h6>
              <p class="text-center">
                <i>{{ fresturaReviews }}</i>
              </p>
            </div>
          </div>
          <div class="_widget-item">
            <div class="_item-wrapper">
              <h5 class="text-center fw-600">Active</h5>
              <hr width="1" />
              <h6 class="text-center">
                <b>Comments</b>
              </h6>
              <p class="text-center">
                <i>{{ fresturaComments }}</i>
              </p>
            </div>
          </div>
        </div>
      </div>
    </CRow>
    <!-- New Widget Ends -->
    <!-- 1st  -->
    <CRow class="gridstyle">
      <div class="col-lg-4 col-md-12 col-sm-12">
        <CCard>
          <CCardBody>
            <div v-if="loader_starcommentreview">
              <semipolar-spinner
                :animation-duration="2000"
                :size="80"
                color="blue"
              ></semipolar-spinner>
            </div>
            <div v-else>
              <CDataTable
                :items="rating_count"
                :fields="fields_count"
                hover
                striped
                bordered
                large
                fixed
                caption="Different Values"
              />
            </div>
          </CCardBody>
        </CCard>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12">
        <CCard>
          <CCardBody>
            <div v-if="loader_starcommentreview">
              <semipolar-spinner
                :animation-duration="2000"
                :size="80"
                color="blue"
              ></semipolar-spinner>
            </div>

            <div v-else class="barChart">
              <highcharts
                class="chart"
                :options="chartOptionsSpline"
              ></highcharts>
            </div>
            <!-- <CCardTitle class="text-center">Reviews vs Comments data</CCardTitle> -->
          </CCardBody>
        </CCard>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12">
        <CCard>
          <CCardBody>
            <div v-if="loader_starcommentreview">
              <semipolar-spinner
                :animation-duration="2000"
                :size="80"
                color="blue"
              ></semipolar-spinner>
            </div>
            <div v-else>
              <CChartPie
                style="height: 250px"
                :datasets="donutDatasets"
                :labels="label_pie_chart"
                :options="{ maintainAspectRatio: false }"
              />
            </div>
          </CCardBody>
        </CCard>
      </div>
    </CRow>

    <!-- 3rd -->
    <CCard>
      <CCardTitle class="text-center"
        >Reviews vs comments over the time</CCardTitle
      >
      <CCardTitle class="text-center">Avg. star score over the time</CCardTitle>
      <CRow>
        <CCol class="col-12 p-3">
          <div
            v-if="loader_reviewsvscommentovertimedata"
            class="barChart col-md-12 text-center"
          >
            <semipolar-spinner
              :animation-duration="2000"
              :size="80"
              color="blue"
            ></semipolar-spinner>
          </div>

          <div v-else class="barChart col-md-12">
            <!-- <bar-chart height="300" width="1000" :chart-data="barchartDatacollection"></bar-chart> -->
            <highcharts
              class="chart"
              :options="ChartReviewVsCommentOptions"
            ></highcharts>
          </div>
        </CCol>
      </CRow>
    </CCard>
    <!-- 4th -->
    <CRow>
      <div class="col-lg-6 col-md-12">
        <CCard>
          <CCardTitle class="text-center">-Avg stars</CCardTitle>
          <div v-if="loader_avgstarday" class="col-md-12 text-center">
            <semipolar-spinner
              :animation-duration="2000"
              :size="80"
              color="blue"
            ></semipolar-spinner>
          </div>
          <div v-else id="chart-container">
            <highcharts
              class="chart"
              :options="barChartLeftOptionsSpline"
            ></highcharts>
          </div>
        </CCard>
      </div>
      <div class="col-lg-6 col-md-12">
        <CCard>
          <CCardTitle class="text-center">-Avg stars</CCardTitle>
          <div v-if="loader_avgstarmonth" class="col-md-12 text-center">
            <semipolar-spinner
              :animation-duration="2000"
              :size="80"
              color="blue"
            ></semipolar-spinner>
          </div>
          <div v-else id="chart-container">
            <highcharts
              class="chart"
              :options="barChartRightOptionsSpline"
            ></highcharts>
          </div>
        </CCard>
      </div>
    </CRow>
    <!-- 2nd -->
    <CCard>
      <CCol class="col-12 p-2">
        <CCol sm="12" style="height: 500px; overflow-y: auto">
          <div v-if="loader_commenttable_data">
            <semipolar-spinner
              :animation-duration="2000"
              :size="80"
              color="blue"
            ></semipolar-spinner>
          </div>
          <div v-else>
            <CDataTable
              :items="commenttable_data"
              :fields="fields1"
              hover
              striped
              bordered
              large
              fixed
              column-filter
              sorter
            >
              <template #createTime="{ item }">
                <td>
                  {{ item.createTime | formatDate }}
                </td>
              </template>
            </CDataTable>
          </div>

          <div v-if="loadMore">
            <scroll-loader
              :loader-method="getcommenttabledata"
              :loader-enable="loadMore"
            >
              <semipolar-spinner
                :animation-duration="2000"
                :size="80"
                color="blue"
              ></semipolar-spinner>
            </scroll-loader>
          </div>
          <!--                   //:fields="fields_data"
        -->
        </CCol>
      </CCol>
      <!-- <CCol class="col-12 p-3">
          <div class="barChart col-md-12" style="height:200">
            <CChartBar :datasets="barchartDatasets1" :labels="['1', '2', '3','4','5',]" />
          </div>
      </CCol>-->
    </CCard>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import store from "../store";
import MainChartExample from "./charts/MainChartExample";
import WidgetsDropdown from "./widgets/WidgetsDropdown";
import WidgetsBrand from "./widgets/WidgetsBrand";
import { CChartLineSimple, CChartBarSimple } from "./charts/index.js";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/scss/index.scss";
import { CChartDoughnut, CChartPie, CChartBar } from "@coreui/vue-chartjs";
import BarChart from "./pages/Barchart.js";
import VueFusionCharts from "vue-fusioncharts";
import Charts from "fusioncharts/fusioncharts.charts";
import FusionCharts from "fusioncharts";
import Column2D from "fusioncharts/fusioncharts.charts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import { FCComponent } from "vue-fusioncharts";
import VueApexCharts from "vue-apexcharts";
import { shuffleArray } from "@/shared/utils";
import { SemipolarSpinner } from "epic-spinners";
import moment from "moment";

import { LOAD_CHILDREN_OPTIONS } from "@riophae/vue-treeselect";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { Chart } from "highcharts-vue";

Charts(FusionCharts);
// Preparing the chart data
const apex_data = {
  series: [
    {
      name: "Money",
      data: [4.5, 4.65, 4.3, 3.8, 2.3, 3.2, 4.8, 5.6, 3.4],
    },
  ],
  chartOptions: {
    chart: {
      type: "bar",
      height: 300,
      stacked: true,
      toolbar: {
        show: true,
      },
      zoom: {
        enabled: true,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
      },
    },
    xaxis: {
      type: "String",
      categories: [
        "Jan 2019",
        "Feb 2019",
        "Mar 2019",
        "Apr 2019",
        "May 2019",
        "June 2019",
        "July 2019",
        "AUG 2019",
        "Sep 2019",
        "Oct 2019",
        "Nov 2019",
        "Dec 2019",
        "Jan 2020",
        "Feb 2020",
        "Mar 2020",
      ],
    },
    legend: {
      position: "top",
      offsetY: 40,
    },
    fill: {
      opacity: 1,
    },
  },
};

export default {
  name: "Dashboard",
  components: {
    DatePicker,
    CChartLineSimple,
    CChartBarSimple,

    MainChartExample,
    WidgetsDropdown,
    WidgetsBrand,
    CChartDoughnut,
    CChartPie,
    CChartBar,
    BarChart,
    SemipolarSpinner,
    Multiselect,
    apexchart: VueApexCharts,
    Treeselect,
    highcharts: Chart,
  },
  updated(){
     //console.log(this.loader_avgstarday);
     
     if(this.starratingSelected == ""){
       this.chartOptionsSpline.xAxis[0].categories = [1,2,3,4,5]
       }
     
  },
  async mounted() {
    var respuesta = await this.getPartners();
    // await this.getGbaReviews();

    // await this.getlocation();
    // this.barchartdata();
    // this.barchartdata1();
    // this.apex_dataConfig();
    // this.apex_dataConfig1();
    // this.apex_dataConfig2();
    // this.apexdata3();
    // this.getLast7DaysData(this.global_gbaReviews);
    // this.getLast30DaysData(this.global_gbaReviews);
    //location.reload();
    
    
  },
  data() {
    var today = new Date();
    var yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    var last7days = new Date(today);
    last7days.setDate(last7days.getDate() - 6);
    var lastmonth = new Date(today);
    lastmonth.setMonth(lastmonth.getMonth() - 1);

    return {
      demographicExcludeSelected: [],
      countriesIncludes: [
        {
          name: "Spain",
          id: 68,
          label: "Spain",
          code: "ES",
          children: null,
        },
      ],
      widget_monthlyRating: "0",
      widget_review: 0,
      widget_comment: 0,
      widget_comment_per: 0,
      widget_rating: 0,
      widget_review_per: 0,
      widget_rating_per: 0,
      widget_perception_per: 0,
      widget_month_rating: 0,
      widget_prev_month_rating: 0,

      widget_review_partner: 0,
      widget_comment_partner: 0,
      widget_rating_partner: 0,
      widget_month_rating_partner: 0,

      widget_review_location: 0,
      widget_comment_location: 0,
      widget_rating_location: 0,
      widget_month_rating_location: 0,

      widget_month_data: [],
      widget_weekdata: [],

      widget_weekdata_rating: [],
      widget_weekdata_comment: [],
      widget_weekdata_review: [],
      widget_reviews: [],
      widget_comments: [],
      widget_rating: [],

      labelbar: [],

      tableData: [],
      commenttable_data: [],
      commenttable_data_partner: [],
      loadMore: false,
      offset_insight: 0,

      reviewsvscommentovertimedata_partner: [],
      avgstarratingperday_partner: [],
      avgstarratingpermonth_partner: [],
      starratingpiechartdata_partner: [],
      reviewsandcommentgraphdata_partner: [],
      commenttable_data_location: [],
      fields: [
        { key: "rating", label: "Star Rating", sortable: true },
        { key: "reviews", label: "Reviews", sortable: true },
        { key: "comments", label: "Comment", sortable: true },
      ],
      fields_count: [
        { key: "starRating", label: "Star Rating", sortable: true },
        { key: "review_count", label: "Reviews", sortable: true },
        { key: "avg_review", label: "Avg Reviews", sortable: true },
        { key: "comment_count", label: "Comment", sortable: true },
        { key: "avg_comment", label: "Avg Comment", sortable: true },
        { key: "participation", label: "Participation(%)", sortable: true },
      ],
      fields1: [
        { key: "createTime", label: "Date", sortable: true },
        { key: "comment", label: "Orignal Comments", sortable: true },
        {
          key: "comment_eng",
          label: "Google translated comment",
          sortable: true,
        },
      ],
      valueData: [],
      tempValueData: [],
      date: "",
      time: "",
      range: "",
      // partnersSelected: "Aire Ancient Baths ES",
      // partners: ["Aire Ancient Baths ES"],

      partners: [],
      partnersArray: [],
      avgRating: [],
      avgRatingArray: [],
      avgReviews: [],
      avgReviewsArray: [],
      partnerSelected: "",
      partner_ids: [],
      locations: [],
      locations1: [[]],
      locations2: [
        [
          {
            id: "fruits",
            label: "Fruits",
            children: [
              {
                id: "apple",
                label: "Apple",
                isNew: true,
              },
              {
                id: "grapes",
                label: "Grapes",
              },
              {
                id: "pear",
                label: "Pear ",
              },
              {
                id: "strawberry",
                label: "Strawberry",
              },
              {
                id: "watermelon",
                label: "Watermelon",
              },
            ],
          },
          {
            id: "vegetables",
            label: "Vegetables",
            children: [
              {
                id: "corn",
                label: "Corn ",
              },
              {
                id: "carrot",
                label: "Carrot ",
              },
              {
                id: "eggplant",
                label: "Eggplant",
              },
              {
                id: "tomato",
                label: "Tomato",
              },
            ],
          },
        ],
      ],
      locationsArray: [],
      locationSelected: [],
      locationSelected1: "",

      starRating: [],
      starRating_unique: [],
      starRating_unique1: [
        { label: 1, value: 1 },
        { label: 2, value: 2 },
        { label: 3, value: 3 },
        { label: 4, value: 4 },
        { label: 5, value: 5 },
      ],
      starratingSelected: "",
      createTimeFilter: [],
      searchLocation: [],
      shortcuts: [
        {
          text: "Today",
          onClick: () => {
            this.range = [today, today];
          },
        },
        {
          text: "YesterDay",
          onClick: () => {
            this.range = [yesterday, yesterday];
          },
        },
        {
          text: "Last 7 Days",
          onClick: () => {
            this.range = [last7days, last7days];
          },
        },
        {
          text: "Last Month",
          onClick: () => {
            this.range = [lastmonth, lastmonth];
          },
        },
      ],
      timePickerOptions: {
        start: "00:00",
        step: "00:30",
        end: "23:30",
      },
      // userscomments: [
      //   {
      //     Date: "mar 11, 2020",
      //     Original_Comments: "Google_Translated_Comments",
      //     Google_Translated_Comments:
      //       "el sitio muy bonito, los baños, los masajes, el personal todo perfecto. inolvidable el baño desde la azotea con vista à la giralda!!",
      //   },
      //   {
      //     Date: "mar 11, 2020",
      //     Original_Comments:
      //       "A faire ,J ai tout apprécié, les différents bains ,le massage ,les boissons mis à disposition ,l attention dans les vestiaires avec les produits de la marque Dove, et le clou du spectacle la terrasse en haut du spa ,on peut y voir tous les monuments de Séville allongée dans la piscine chauffée !!!!!MAGNIFIQUE.",
      //     Google_Translated_Comments:
      //       "el sitio muy bonito, los baños, los masajes, el personal todo perfecto. inolvidable el baño desde la azotea con vista à la giralda!!",
      //   },
      //   {
      //     Date: "mar 11, 2020",
      //     Original_Comments:
      //       "el sitio muy bonito, los baños, los masajes, el personal todo perfecto. inolvidable el baño desde la azotea con vista à la giralda!!",
      //     Google_Translated_Comments:
      //       "el sitio muy bonito, los baños, los masajes, el personal todo perfecto. inolvidable el baño desde la azotea con vista à la giralda!!",
      //   },
      //   {
      //     Date: "mar 11, 2020",
      //     Original_Comments:
      //       "el sitio muy bonito, los baños, los masajes, el personal todo perfecto. inolvidable el baño desde la azotea con vista à la giralda!!",
      //     Google_Translated_Comments:
      //       "el sitio muy bonito, los baños, los masajes, el personal todo perfecto. inolvidable el baño desde la azotea con vista à la giralda!!",
      //   },
      //   {
      //     Date: "mar 11, 2020",
      //     Original_Comments:
      //       "el sitio muy bonito, los baños, los masajes, el personal todo perfecto. inolvidable el baño desde la azotea con vista à la giralda!!",
      //     Google_Translated_Comments:
      //       "el sitio muy bonito, los baños, los masajes, el personal todo perfecto. inolvidable el baño desde la azotea con vista à la giralda!!",
      //   },
      // ],
      barchartDatacollection: { labels: [], datasets: [], options: {} },
      apex_dataconfig_data: {
        dataSource: {
          chartOptions: {
            chart: {
              type: "line",
              id: "basic-bar",
            },
          },
        },
      },
      abcRating: [],
      abcReviews: [],
      abcComments: [],
      searchLocationId: [],
      global_yearlyReviews: [],
      global_gbaReviews: [],
      global_gbaReviewsArray: [],
      global_gbaReviewsLocation: [],
      selectedpartner: "Aire Ancient Baths ES",
      selectedrating: "1",
      selectedlocation: "",
      selectedTime: "",
      apexdata_label: [],
      apexdata_label_days: [],
      rating_count: [],
      rating_count_piechart: [],
      isLoading: false,
      loader_starcommentreview: false,
      loader_commenttable_data: false,
      loader_reviewsvscommentovertimedata: false,
      loader_avgstarday: false,
      loader_avgstarmonth: false,

      chartOptionsSpline: {
        chart: {
          zoomType: "xy",
        },
        title: {
          text: "",
        },
        xAxis: [
          {
            categories: [1,2,3,4,5],
            crosshair: true,
          },
        ],
        yAxis: [
          {
            // Primary yAxis
            labels: {
              format: "{value}",
              style: {
                color: "#595959",
              },
            },
            title: {
              text: "",
              style: {
                color: "#595959",
              },
            },
          },
          {
            // Secondary yAxis
            title: {
              text: "Participation %",
              style: {
                color: "green",
              },
            },
            labels: {
              formatter: function(){
                return this.value * 100 + "%" 
              },
              //format: "{value}%",
              style: {
                color: "green",
              },
            },
            opposite: true,
          },
        ],
        credits: false,
        tooltip: {
          shared: true,
        },
        legend: {
          layout: "horizontal",
          align: "center",
          // layout: "vertical",
          // align: "left",
          // x: 120,
          // verticalAlign: "top",
          // y: 100,
          // floating: true,
          backgroundColor: "rgba(255,255,255,0.25)",
        },
        series: [
          {
            name: "Reviews",
            type: "column",
            color: "#F0FF5D",
            data: [],
            tooltip: {
              valueSuffix: " ",
            },
          },
          {
            name: "Comments",
            type: "column",
            color: "#595959",
            data: [],
            tooltip: {
              valueSuffix: " ",
            },
          },
          {
            name: "% Participacion",
            type: "spline",
            color: "red",
            yAxis: 1,
            data: [],
            tooltip: {
              valueSuffix: "%",
            },
          },
          // {
          //   name: "(nºcomments / nºreviews)",
          //   type: "spline",
          //   color: "green",
          //   data: [],
          //   tooltip: {
          //     valueSuffix: "",
          //   },
          // },
        ],
      },
      ChartReviewVsCommentOptions: {
        chart: {
          zoomType: "xy",
        },
        title: {
          text: "",
        },
        xAxis: [
          {
            categories: [1,2,3,4,5],
            crosshair: true,
          },
        ],
        yAxis: [
          {
            // Primary yAxis
            labels: {
              format: "{value}",
              style: {
                color: "#595959",
              },
            },
            title: {
              text: "",
              style: {
                color: "#595959",
              },
            },
          },
          {
            // Secondary yAxis
            title: {
              text: "Participation %",
              style: {
                color: "green",
              },
            },
            labels: {
              //format: "{value}%",
              formatter: function(){
                return (this.value * 100).toFixed(2) + '%';
              },
              style: {
                color: "green",
              },
            },
            opposite: true,
          },
        ],
        credits: false,
        tooltip: {
          shared: true,
        },
        legend: {
          layout: "horizontal",
          align: "center",
          // layout: "vertical",
          // align: "left",
          // x: 120,
          // verticalAlign: "top",
          // y: 100,
          // floating: true,
          backgroundColor: "rgba(255,255,255,0.25)",
        },
        series: [
          {
            name: "Reviews",
            type: "column",
            // yAxis: 1,
            color: "#F0FF5D",
            data: [],
            tooltip: {
              valueSuffix: " ",
            },
          },
          {
            name: "Comments",
            type: "column",
            // yAxis: 1,
            color: "#595959",
            data: [],
            tooltip: {
              valueSuffix: " ",
            },
          },
          {
            name: "% Participacion",
            type: "spline",
            color: "#5700FF",
            yAxis: 1,
            data: [],
            tooltip: {
              valueSuffix: "%",
            },
          },
          // {
          //   name: "(nºcomments / nºreviews)",
          //   type: "spline",
          //   color: "green",
          //   data: [],
          //   tooltip: {
          //     valueSuffix: " ",
          //   },
          // },
        ],
      },
      barChartRightOptionsSpline: {
        chart: {
          zoomType: "xy",
        },
        title: {
          text: "",
        },
        xAxis: [
          {
            categories: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ],
            crosshair: true,
          },
        ],
        yAxis: [
          {
            // Primary yAxis
            labels: {
              format: "{value}%",
              // style: {
              //   color: Highcharts.getOptions().colors[2],
              // },
            },
            title: {
              text: "Star Rating(%)",
              // style: {
              //   color: Highcharts.getOptions().colors[2],
              // },
            },
            opposite: true,
          },
          {
            // Secondary yAxis
            gridLineWidth: 0,
            title: {
              text: "Star Rating",
              // style: {
              //   color: Highcharts.getOptions().colors[0],
              // },
            },
            labels: {
              format: "{value}",
              // style: {
              //   color: Highcharts.getOptions().colors[0],
              // },
            },
          },
        ],
        credits: false,
        tooltip: {
          shared: true,
        },
        legend: {
          layout: "horizontal",
          align: "center",
          // layout: "vertical",
          // align: "left",
          // x: 120,
          // verticalAlign: "top",
          // y: 100,
          // floating: true,
          backgroundColor: "rgba(255,255,255,0.25)",
        },
        series: [
          {
            name: "Star Rating",
            type: "column",
            yAxis: 1,
            color: "#595959",
            data: [],
            tooltip: {
              valueSuffix: " ",
            },
          },
          {
            name: "Star Rating %",
            type: "spline",
            color: "#FB963E",
            data: [],
            tooltip: {
              valueSuffix: "%",
            },
          },
        ],
      },
      barChartLeftOptionsSpline: {
        chart: {
          zoomType: "xy",
        },
        title: {
          text: "",
        },
        xAxis: [
          {
            categories: [],
            crosshair: true,
          },
        ],
        yAxis: [
          {
            // Primary yAxis
            labels: {
              format: "{value}%",
            },
            title: {
              text: "Star Rating(%)",
            },
            opposite: true,
          },
          {
            // Secondary yAxis
            gridLineWidth: 0,
            title: {
              text: "Star Rating",
            },
            labels: {
              format: "{value}",
            },
          },
        ],
        credits: false,
        tooltip: {
          shared: true,
        },
        legend: {
          layout: "horizontal",
          align: "center",
          // layout: "vertical",
          // align: "left",
          // x: 120,
          // verticalAlign: "top",
          // y: 100,
          // floating: true,
          backgroundColor: "rgba(255,255,255,0.25)",
        },
        series: [
          {
            name: "Star Rating",
            type: "column",
            yAxis: 1,
            color: "#FB963E",
            data: [],
            tooltip: {
              valueSuffix: " ",
            },
          },
          {
            name: "Star Rating %",
            type: "spline",
            color: "#595959",
            data: [],
            tooltip: {
              valueSuffix: "%",
            },
          },
        ],
      },
      // First Line Chart
      graphReviewColumn: [],
      graphCommentColumn: [],
      graphReviewPercent: [],
      graphCommentPercent: [],

      // Rating vs Reviews Configurable Options
      ChartReviewVsCommentOptionsXaxisDataPoint: [],
      ChartReviewVsCommentOptionsReviewColumn: [],
      ChartReviewVsCommentOptionsCommentColumn: [],
      ChartReviewVsCommentOptionsReviewPercent: [],
      ChartReviewVsCommentOptionsCommentPercent: [],

      // Avg Stars right widget Configurable Options
      barChartRightOptionsXaxisDataPoint: [],
      barChartRightOptionsDataColumns: [],
      barChartRightOptionsPercentColumns: [],

      // Avg Stars left widget Configurable Options
      barChartLeftOptionsXaxisDataPoint: [],
      barChartLeftOptionsDataColumns: [],
      barChartLeftOptionsPercentColumns: [],

      fresturaReviews: 0,
      fresturaComments: 0,
    };
  },
  computed: {
    computedItems() {
      return global_gbaReviews.map((item) => {
        return {
          ...item,
          createTime: item.createTime,
          // registeredDate: item.registered.date
        };
      });
    },
    label_pie_chart() {
      return this.starRating_unique.map((item) => {
        return item.value;
        
      });
    },
    donutDatasets() {
      var data1 = this.rating_count_piechart;
      var ratings = [];
      var comment_count = [];
      var review_count = [];
      data1.forEach((t) => {
        review_count.push(t.review_count);
      });

      //[ "#00D8FF", "#00L8FF", "#DD1B16", "#E46651", "#E0F7FA", "#00C8FF", ],
      return [
        {
          backgroundColor: [
            "#5700ff",
            "#eeff41",
            "#3d3d3d",
            "#7c7c7c",
            "#b08fff",
            "#D3C5FF",
            "#FAFF99",
            "#CCCCCC",
          ],
          data: review_count, //data.reviews,
          legend: {
            position: "right",
            show: true,
          },
        },
      ];
    },
  },
  methods: {
    xAxisFilter(){
      var indice = this.starratingSelected
      var datosX = []
        
        for (let arrayDeValores of indice) {
        var valor = arrayDeValores.value
        //console.log(valor)
        datosX.push(valor)
        }
        this.chartOptionsSpline.xAxis[0].categories = datosX.sort()
      
    },
    getfilterPartner() {
      // console.log("this.partnerSelected ::::: ", this.partnerSelected);
      var partner_names = [];
      this.partnerSelected.forEach((partner) => {
        partner_names.push(partner.name);
      });

      if (this.partnerSelected.length > 0) {
        // console.log("this.partnerSelected ::::: ", this.partnerSelected);

        var gbareview = this.global_gbaReviewsArray;
        // console.log("gbareview ::: ",this.global_gbaReviewsArray.length);
        var filtered_data_review = gbareview.filter((item, index) => {
          if (item.location_id.partner_id !== undefined) {
            return partner_names.includes(item.location_id.partner_id.name);
          }
        });
        this.global_gbaReviews = filtered_data_review;
        // console.log("gbareview after filter:::if ", filtered_data_review);
        this.getreview_Count(filtered_data_review);
        this.apex_dataConfig1(filtered_data_review);
        this.getreview_CountMonth(filtered_data_review);
        this.getreview_Countquarter(filtered_data_review);
      } else {
        // console.log("this.partnerSelected None::::: ");
        this.global_gbaReviews = this.global_gbaReviewsArray;
        // console.log("gbareview after filter:::else ", filtered_data_review);
        this.getreview_Count(this.global_gbaReviews);
        this.apex_dataConfig1(this.global_gbaReviews);
        this.getreview_CountMonth(this.global_gbaReviews);
        this.getreview_Countquarter(this.global_gbaReviews);
      }
    },

    getfilterlocationName() {
      // console.log("this.locationSelected ::::: ", this.locationSelected);
      var location_names = [];
      this.offset_insight = 0;
      this.commenttable_data = [];
      this.commenttable_data_partner = [];

      // this.starratingSelected=[];
      // this.range=[];
      this.locationSelected.forEach((location) => {
        // console.log("location selected :::::", location);
        location_names.push(location.locationName);
      });
      // console.log(
      //   "selected location length==>",
      //   this.locationSelected,
      //   this.partner_ids
      // );
      if (this.locationSelected.length > 0) {
        if (this.partner_ids[0] == this.locationSelected[0]) {
          this.get7daysavgRating();
          this.get7dayscomments();
          this.get7monthsavgRating();
          this.getreviewsandcommentgraphdata();
          this.getstarratingpiechartdata();
          this.getcommenttabledata();
          this.getreviewsvscommentovertime();
          this.getavgstarratingperday();
          this.getavgstarratingpermonth();
        } else {
          this.get7daysavgRating();
          this.get7dayscomments();
          this.get7monthsavgRating();
          this.getreviewsandcommentgraphdata();
          this.getstarratingpiechartdata();
          this.getcommenttabledata();
          this.getreviewsvscommentovertime();
          this.getavgstarratingperday();
          this.getavgstarratingpermonth();
          // this.get7daysavgRatingbyLocation();
          // this.get7dayscomments();
          // this.get7monthsavgRatingbyLocation();
          // this.getreviewsandcommentgraphdatabyLocation();
          // this.getstarratingpiechartdatabyLocation();
          // this.getcommenttabledatabyLocation();
          // this.getreviewsvscommentovertimebyLocation();
          // this.getavgstarratingperdaybyLocation();
          // this.getavgstarratingpermonthbyLocation();
        }
      } else {
        // console.log("this.partnerSelected None::::: ");
        if (this.partner_ids.length > 0) {
          this.get7daysavgRating();
          this.get7dayscomments();
          this.get7monthsavgRating();
          this.getreviewsandcommentgraphdata();
          this.getstarratingpiechartdata();
          this.getcommenttabledata();
          this.getreviewsvscommentovertime();
          this.getavgstarratingperday();
          this.getavgstarratingpermonth();
        } else {
          this.widget_rating = 0;
          this.widget_comment = 0;
          this.widget_review = 0;
          this.widget_month_rating = 0;
          this.rating_count = [];
          this.rating_count_piechart = [];
          this.starRating_unique = [];
          this.commenttable_data = [];
        }
      }
    },

    getfilterlocationNamenew() {
      this.offset_insight = 0;
      this.commenttable_data = [];
      this.commenttable_data_partner = [];

      // console.log("this.locationSelected ::::: ", this.locationSelected);
      var location_names = [];
      this.locationSelected.forEach((location) => {
        location_names.push(location.locationName);
      });
      // console.log("selected location length==>", this.locationSelected);
      if (this.locationSelected.length > 0) {
        var gbareview = this.global_gbaReviewsArray;
        // console.log("gbareview location::: ", gbareview);
        // var filtered_data_review = gbareview.filter((item) => {
        //   console.log("item:", item);
        //   return location_names.includes(item.location_id.locationName);
        // });

        var filtered_data_review = gbareview.filter((item) => {
          // console.log("item:", item);
          if (
            this.locationSelected.includes(item.location_id.partner_id.name)
          ) {
            // console.log("this.demographicExcludeSelected.includes(item.partner_name)", this.demographicExcludeSelected.includes(item.partner_name));
            return this.locationSelected.includes(
              item.location_id.partner_id.name
            );
          } else {
            // console.log(
            //   "in else location filter ::: ",
            //   item.location_id.locationName +
            //     " - " +
            //     item.location_id.city +
            //     " - " +
            //     item.location_id.description
            // );
            return this.locationSelected.includes(
              item.location_id.locationName +
                " - " +
                item.location_id.city +
                " - " +
                item.location_id.description
            );
          }
        });

        // console.log(
        //   filtered_data_review,
        //   "============123 location filtered_data_review"
        // );
        this.global_gbaReviews = filtered_data_review;
        this.global_gbaReviewsLocation = filtered_data_review;
        // console.log("gbareview after filter111::: ",filtered_data_review);
        this.getreview_Count(filtered_data_review);
        this.apex_dataConfig1(filtered_data_review);
        this.getreview_CountMonth(filtered_data_review);
        this.getreview_Countquarter(filtered_data_review);
      } else {
        // console.log("this.partnerSelected None::::: ");
        this.global_gbaReviews = this.global_gbaReviewsArray;
        // console.log("gbareview after filter::: ",filtered_data_review);
        this.getreview_Count(this.global_gbaReviews);
        this.apex_dataConfig1(this.global_gbaReviews);
        this.getreview_CountMonth(this.global_gbaReviews);
        this.getreview_Countquarter(this.global_gbaReviews);
      }
    },

    getfilterstarRating() {
      var starRatings = [];
      this.offset_insight = 0;
      this.commenttable_data = [];
      this.commenttable_data_partner = [];

      this.starratingSelected.forEach((rating) => {
        starRatings.push(rating.value);
      });
      // console.log("selectede ==>", this.starratingSelected, starRatings);
      if (this.starratingSelected.length > 0) {
        this.xAxisFilter()
        // this.get7daysavgRating();
        // console.log("before filter  starratingSelected", comment_data.length);
        // var gbareview = [];
        // console.log("this.partnerSelected.length", this.locationSelected);
        if (this.locationSelected.length > 0) {
          if (this.partner_ids[0] == this.locationSelected[0]) {
            // this.getlocation();
            this.get7daysavgRating();
            this.get7dayscomments();
            this.get7monthsavgRating();
            this.getreviewsandcommentgraphdata();
            this.getstarratingpiechartdata();
            this.getcommenttabledata();
            this.getreviewsvscommentovertime();
            this.getavgstarratingperday();
            this.getavgstarratingpermonth();
          } else {
            // this.get7daysavgRatingbyLocation();
            // this.get7dayscommentsbyLocation();
            // this.get7monthsavgRatingbyLocation();
            // this.getreviewsandcommentgraphdatabyLocation();
            // this.getstarratingpiechartdatabyLocation();
            // this.getcommenttabledatabyLocation();
            // this.getreviewsvscommentovertimebyLocation();
            // this.getavgstarratingperdaybyLocation();
            // this.getavgstarratingpermonthbyLocation();
            this.get7daysavgRating();
            this.get7dayscomments();
            this.get7monthsavgRating();
            this.getreviewsandcommentgraphdata();
            this.getstarratingpiechartdata();
            this.getcommenttabledata();
            this.getreviewsvscommentovertime();
            this.getavgstarratingperday();
            this.getavgstarratingpermonth();
          }
        } else if (this.partner_ids.length > 0) {
          this.get7daysavgRating();
          this.get7dayscomments();
          this.get7monthsavgRating();
          this.getreviewsandcommentgraphdata();
          this.getstarratingpiechartdata();
          this.getcommenttabledata();
          this.getreviewsvscommentovertime();
          this.getavgstarratingperday();
          this.getavgstarratingpermonth();
          // gbareview = this.global_gbaReviews;
           //console.log("starRating==>", this.starratingSelected);
        } else {
        }
      } else {
        // console.log("this.starratingSelected None::::: ");
        if (this.locationSelected.length > 0) {
          if (this.partner_ids[0] == this.locationSelected[0]) {
            this.get7daysavgRating();
            this.get7dayscomments();
            this.get7monthsavgRating();
            this.getreviewsandcommentgraphdata();
            this.getstarratingpiechartdata();
            this.getcommenttabledata();
            this.getreviewsvscommentovertime();
            this.getavgstarratingperday();
            this.getavgstarratingpermonth();
          } else {
            this.get7daysavgRating();
            this.get7dayscomments();
            this.get7monthsavgRating();
            this.getreviewsandcommentgraphdata();
            this.getstarratingpiechartdata();
            this.getcommenttabledata();
            this.getreviewsvscommentovertime();
            this.getavgstarratingperday();
            this.getavgstarratingpermonth();
            // this.get7daysavgRatingbyLocation();
            // this.get7dayscommentsbyLocation();
            // this.get7monthsavgRatingbyLocation();
            // this.getreviewsandcommentgraphdatabyLocation();
            // this.getstarratingpiechartdatabyLocation();
            // this.getcommenttabledatabyLocation();
            // this.getreviewsvscommentovertimebyLocation();
            // this.getavgstarratingperdaybyLocation();
            // this.getavgstarratingpermonthbyLocation();
          }
        } else if (this.partner_ids.length > 0) {
          this.get7daysavgRating();
          this.get7dayscomments();
          this.get7monthsavgRating();
          this.getreviewsandcommentgraphdata();
          this.getstarratingpiechartdata();
          this.getcommenttabledata();
          this.getreviewsvscommentovertime();
          this.getavgstarratingperday();
          this.getavgstarratingpermonth();

          // this.global_gbaReviews = this.global_gbaReviews;
          // console.log("this gbareview data from starRating==>", gbareview);
        } else {
          this.widget_rating = 0;
          this.widget_comment = 0;
          this.widget_review = 0;
          this.widget_month_rating = 0;
          this.rating_count = [];
          this.rating_count_piechart = [];
          this.starRating_unique = [];
          this.commenttable_data = [];
        }
      }
    },
    dateSelected(date) {
      this.offset_insight = 0;
      this.commenttable_data = [];
      this.commenttable_data_partner = [];

      if (this.range[0] !== null || this.range[1] !== null) {
        // console.log("In date filer========= ", date , moment(this.range[0]).format('YYYY-MM-DD'),moment(date[1]).format('YYYY-MM-DD'));
        var start = this.range[0];
        var end = this.range[1];
        // console.log(this.partnerSelected.length);
        if (this.locationSelected.length > 0) {
          if (this.partner_ids[0] == this.locationSelected[0]) {
            this.getlocation();
            this.get7daysavgRating();
            this.get7dayscomments();
            this.get7monthsavgRating();
            this.getreviewsandcommentgraphdata();
            this.getstarratingpiechartdata();
            this.getcommenttabledata();
            this.getreviewsvscommentovertime();
            this.getavgstarratingperday();
            this.getavgstarratingpermonth();
          } else {
            this.get7daysavgRating();
            this.get7dayscomments();
            this.get7monthsavgRating();
            this.getreviewsandcommentgraphdata();
            this.getstarratingpiechartdata();
            this.getcommenttabledata();
            this.getreviewsvscommentovertime();
            this.getavgstarratingperday();
            this.getavgstarratingpermonth();
            // this.get7daysavgRatingbyLocation();
            // this.get7dayscommentsbyLocation();
            // this.get7monthsavgRatingbyLocation();
            // this.getreviewsandcommentgraphdatabyLocation();
            // this.getstarratingpiechartdatabyLocation();
            // this.getcommenttabledatabyLocation();
            // this.getreviewsvscommentovertimebyLocation();
            // this.getavgstarratingperdaybyLocation();
            // this.getavgstarratingpermonthbyLocation();
          }
        } else if (this.partner_ids.length > 0) {
          this.get7dayscomments();
          this.get7monthsavgRating();
          this.getreviewsandcommentgraphdata();
          this.getstarratingpiechartdata();
          this.getcommenttabledata();
          this.getreviewsvscommentovertime();
          this.getavgstarratingperday();
          this.getavgstarratingpermonth();
        } else {
          this.get7dayscomments();
          this.get7monthsavgRating();
          this.getreviewsandcommentgraphdata();
          this.getstarratingpiechartdata();
          this.getcommenttabledata();
          this.getreviewsvscommentovertime();
          this.getavgstarratingperday();
          this.getavgstarratingpermonth();
        }
      } else {
        if (this.locationSelected.length > 0) {
          if (this.partner_ids[0] == this.locationSelected[0]) {
            this.get7daysavgRating();
            this.get7dayscomments();
            this.get7monthsavgRating();
            this.getreviewsandcommentgraphdata();
            this.getstarratingpiechartdata();
            this.getcommenttabledata();
            this.getreviewsvscommentovertime();
            this.getavgstarratingperday();
            this.getavgstarratingpermonth();
          } else {
            this.get7daysavgRating();
            this.get7dayscomments();
            this.get7monthsavgRating();
            this.getreviewsandcommentgraphdata();
            this.getstarratingpiechartdata();
            this.getcommenttabledata();
            this.getreviewsvscommentovertime();
            this.getavgstarratingperday();
            this.getavgstarratingpermonth();
            // this.get7daysavgRatingbyLocation();
            // this.get7dayscommentsbyLocation();
            // this.get7monthsavgRatingbyLocation();
            // this.getreviewsandcommentgraphdatabyLocation();
            // this.getstarratingpiechartdatabyLocation();
            // this.getcommenttabledatabyLocation();
            // this.getreviewsvscommentovertimebyLocation();
            // this.getavgstarratingperdaybyLocation();
            // this.getavgstarratingpermonthbyLocation();
          }
        }
        if (this.partner_ids.length > 0) {
          this.getlocation();
          this.get7daysavgRating();
          this.get7dayscomments();
          this.get7monthsavgRating();
          this.getreviewsandcommentgraphdata();
          this.getstarratingpiechartdata();
          this.getcommenttabledata();
          this.getreviewsvscommentovertime();
          this.getavgstarratingperday();
          this.getavgstarratingpermonth();
        } else {
          this.widget_rating = 0;
          this.widget_comment = 0;
          this.widget_review = 0;
          this.widget_month_rating = 0;
          this.rating_count = [];
          this.rating_count_piechart = [];
          this.starRating_unique = [];
          this.commenttable_data = [];
        }
      }
    },

    customLabel({ locationName, city, description }) {
      return `${locationName} – ${city} – ${description}`;
    },
    async getlocation() {
      var gbalocation = store.getters.getlocationbyPartner;
      // console.log(
      //   "item location1111 ::::::===>",
      //   gbalocation.length,
      //   this.isLoading
      // );

      var options = [];
      // if (gbalocation.length === 0) {
      // this.isLoading = true;
      // console.log("gbalocation 12", gbalocation.length);
      var partner_ids = this.partner_ids;
      // console.log(partner_ids, "::::::::; partner_ids");
      store.dispatch("getlocationbyPartner", partner_ids).then(() => {
        gbalocation = store.getters.getlocationbyPartner;
        // console.log("gbalocation", gbalocation);
        // var gbalocation_sorted = _.sortBy(
        //   gbalocation,
        //   "location.partner_id.value"
        // );
        var locationsByPartner = [];

        var prev_key = "";
        var data = [];
        var data1 = [];
        // console.log("gbalocation :::: ", gbalocation);
        gbalocation.map((location) => {
          // console.log("@@@@!!!! :::: ", location);
          if (partner_ids.includes(location.partner_id[0])) {
            locationsByPartner.push(location);
            var custom_label =
              location.locationName +
              " - " +
              location.city +
              " - " +
              location.description;

            var key = location.partner_id[1];
            if (prev_key !== key) {
              // console.log(
              //   "@@@@@@@@@@@@@@2 main ",
              //   prev_key,
              //   key,
              //   data,
              //   custom_label
              // );
              if (
                data.some((loc) => location.label === location.partner_id[1])
              ) {
                // console.log("already_exists");
                var index1 = _.findIndex(data, {
                  label: location.partner_id[1],
                });
                data[index1].children.push({
                  id: location.id,
                  label: custom_label,
                  isNew: true,
                });
              } else {
                // console.log("doesnot exists");
                data.push({
                  id: location.partner_id[0],
                  label: location.partner_id[1],
                  children: [
                    {
                      id: location.id,
                      label: custom_label,
                      isNew: true,
                    },
                  ],
                });
              }
              // console.log("data ::: ", data);
              prev_key = key;
            } else {
              var index1 = _.findIndex(data, { label: location.partner_id[1] });
              // console.log(
              //   "!!!!!!!!!!1 ",
              //   prev_key,
              //   index1,
              //   key,
              //   data,
              //   data[index1]
              // );

              data[index1].children.push({
                id: location.id, //+"_"+key,
                label: custom_label,
                isNew: true,
              });
              // console.log(
              //   data[index1].children,
              //   key,
              //   "data[index1].children",
              //   custom_label
              // );
            }
          }
        });
        // console.log("data ::: ", data);
        options.push(data);
        // console.log(
        //   "locationsByPartner ::::: ",
        //   options,
        //   locationsByPartner.length
        // );
        this.isLoading = false;

        // this.locations = _.sortBy(locationunique, "locationName");
        this.locations = _(locationsByPartner)
          .chain()
          .sortBy(function (location) {
            return location.locationName;
          })
          .sortBy(function (location) {
            return location.city;
          })
          .value();
        // this.locationsArray = _.sortBy(result, "locationName");
        this.locationsArray = _(locationsByPartner)
          .chain()
          .sortBy(function (location) {
            return location.locationName;
          })
          .sortBy(function (location) {
            return location.city;
          })
          .value();

        this.locations1 = options;
        // console.log("item location@@@: :::::===>", this.locations.length);
      });
    },
    async getPartners() {
      var partners = store.getters.getPartners;
      if (partners.length == 0) {
        this.isLoading = true;
        await store.dispatch("getPartners").then(() => {
          partners = store.getters.getPartners;
          // console.log("partners ::::: ", partners);
          this.partners = partners;
          this.partnersArray = partners;
          return;
        });
      } else {
        this.partners = partners;
        this.partnersArray = partners;
        return;
      }
    },
    /*for partner api*/
    async get7daysavgRating() {
      var partner_ids = [];
      var business_unit_ids = [];
      var location_ids = [];
      var starRatings = [];
      var create_date = [];

      var partner_ids = this.partner_ids;

      if (this.locationSelected.length > 0) {
        this.locationSelected.forEach((location) => {
          location_ids.push(location);
        });
      }
      // console.log(
      //   "this.locationSelected , location_ids ::: ",
      //   this.locationSelected,
      //   location_ids
      // );
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      // console.log(
      //   "selected ==>",
      //   this.starratingSelected,
      //   starRatings,
      //   this.range
      // );
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        location_ids: location_ids,
        business_unit_ids: business_unit_ids,
        partner_ids: partner_ids,
        starRatings: starRatings,
        create_date: create_date,
        page_ref: "location",
      };

      await store.dispatch("get7daysavgRating", payload).then(() => {
        var avgRating = store.getters.get7daysavgRating;
        // console.log(
        //   "avgRating get7daysavgRating::: ",
        //   avgRating,
        //   store.getters.get7daysavgRating
        // );
        var review_count = 0;
        var starRating = 0;
        var count = 0;
        if (avgRating.length > 0) {
          avgRating.forEach((reviews) => {
            //console.log("reviews in 7 days avg::::", reviews);
            count = count + 1;
            review_count = review_count + reviews.createTime_count;
            starRating = starRating + reviews.starRating_avg;
          });
          this.widget_rating = (starRating / count).toFixed(2);
          this.widget_review = review_count;
          this.widget_rating_partner = (starRating / count).toFixed(2);
          this.widget_review_partner = review_count;
        } else {
          this.widget_rating = 0;
          this.widget_review = 0;
        }
        this.getPrevWeek7daysavgRating();
        this.getFrescuraReviews();
        return;
      });
    },
    async getPrevWeek7daysavgRating() {
      var partner_ids = [];
      var business_unit_ids = [];
      var location_ids = [];
      var starRatings = [];
      var create_date = [];

      var partner_ids = this.partner_ids;

      if (this.locationSelected.length > 0) {
        this.locationSelected.forEach((location) => {
          location_ids.push(location);
        });
      }
      // console.log(
      //   "this.locationSelected , location_ids ::: ",
      //   this.locationSelected,
      //   location_ids
      // );
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      // console.log(
      //   "selected ==>",
      //   this.starratingSelected,
      //   starRatings,
      //   this.range
      // );
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        location_ids: location_ids,
        business_unit_ids: business_unit_ids,
        partner_ids: partner_ids,
        starRatings: starRatings,
        create_date: create_date,
        page_ref: "location",
      };

      await store.dispatch("getPrevWeek7daysavgRating", payload).then(() => {
        var avgRating = store.getters.getPrevWeek7daysavgRating;
        // console.log(
        //   "avgRating get7daysavgRating::: ",
        //   avgRating,
        //   store.getters.get7daysavgRating
        // );
        var review_count = 0;
        var starRating = 0;
        var count = 0;

        if (avgRating.length > 0) {
          avgRating.forEach((reviews) => {
            //console.log("reviews in 7 days avg::::", reviews);
            count = count + 1;
            review_count = review_count + reviews.createTime_count;
            starRating = starRating + reviews.starRating_avg;
          });
          let p_widget_rating = (starRating / count).toFixed(2);
          let p_widget_review = review_count;
          this.widget_rating_per = (
            ((this.widget_rating - p_widget_rating) * 100) /
            p_widget_rating
          ).toFixed(2);

          this.widget_review_per = (
            ((this.widget_review - p_widget_review) * 100) /
            p_widget_review
          ).toFixed(2);
        } else {
          this.widget_rating = 0;
          this.widget_review = 0;
        }
        return;
      });
    },
    async get7monthsavgRating() {
      var partner_ids = [];
      var business_unit_ids = [];
      var location_ids = [];
      var starRatings = [];
      var create_date = [];

      var partner_ids = this.partner_ids;

      if (this.locationSelected.length > 0) {
        this.locationSelected.forEach((location) => {
          location_ids.push(location);
        });
      }
      // console.log(
      //   "this.locationSelected , location_ids ::: ",
      //   this.locationSelected,
      //   location_ids
      // );
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      // console.log(
      //   "selected ==>",
      //   this.starratingSelected,
      //   starRatings,
      //   this.range
      // );
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        location_ids: location_ids,
        business_unit_ids: business_unit_ids,
        partner_ids: partner_ids,
        starRatings: starRatings,
        create_date: create_date,
        page_ref: "location",
      };

      await store.dispatch("get7monthsavgRating", payload).then(() => {
        var monthavgRating = store.getters.get7monthsavgRating;
        // console.log("monthavgRating get7daysavgRating::: ", monthavgRating);
        var review_count = 0;
        var starRating = 0;
        var count = 0;
        if (monthavgRating.length > 0) {
          monthavgRating.forEach((reviews) => {
            // console.log("reviews in 7 days avg::::", reviews);
            count = count + 1;
            // review_count = review_count + reviews.__count;
            starRating = starRating + reviews.starRating_avg;
          });

          this.widget_month_rating = (starRating / count).toFixed(2);
          this.widget_month_rating_partner = (starRating / count).toFixed(2);
          this.getPrev7monthsavgRating();
        } else {
          this.widget_month_rating = 0;
        }
        return;
      });
    },
    async getPrev7monthsavgRating() {
      var partner_ids = [];
      var business_unit_ids = [];
      var location_ids = [];
      var starRatings = [];
      var create_date = [];
      this.widget_prev_month_rating = 0;

      var partner_ids = this.partner_ids;

      if (this.locationSelected.length > 0) {
        this.locationSelected.forEach((location) => {
          location_ids.push(location);
        });
      }
      // console.log(
      //   "this.locationSelected , location_ids ::: ",
      //   this.locationSelected,
      //   location_ids
      // );
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      // console.log(
      //   "selected ==>",
      //   this.starratingSelected,
      //   starRatings,
      //   this.range
      // );
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        location_ids: location_ids,
        business_unit_ids: business_unit_ids,
        partner_ids: partner_ids,
        starRatings: starRatings,
        create_date: create_date,
        page_ref: "location",
      };

      await store.dispatch("getPrev7monthsavgRating", payload).then(() => {
        var monthavgRating = store.getters.getPrev7monthsavgRating;
        // console.log("monthavgRating get7daysavgRating::: ", monthavgRating);
        var review_count = 0;
        var starRating = 0;
        var count = 0;
        if (monthavgRating.length > 0) {
          monthavgRating.forEach((reviews) => {
            // console.log("reviews in 7 days avg::::", reviews);
            count = count + 1;
            // review_count = review_count + reviews.__count;
            starRating = starRating + reviews.starRating_avg;
          });

          let widget_prev_month_rating = (starRating / count).toFixed(2);
          this.widget_prev_month_rating = parseFloat(
            ((this.widget_month_rating - widget_prev_month_rating) * 100) /
              widget_prev_month_rating
          ).toFixed(2);
        } else {
          this.widget_prev_month_rating = 0;
        }
        return;
      });
    },
    async get7dayscomments() {
      var widget_comments = 0;
      // var partner_ids = this.partner_ids;
      var avgComments = 0;
      var partner_ids = [];
      var business_unit_ids = [];
      var location_ids = [];
      var starRatings = [];
      var create_date = [];

      var partner_ids = this.partner_ids;

      if (this.locationSelected.length > 0) {
        this.locationSelected.forEach((location) => {
          location_ids.push(location);
        });
      }
      // console.log(
      //   "this.locationSelected , location_ids ::: ",
      //   this.locationSelected,
      //   location_ids
      // );
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      // console.log(
      //   "selected ==>",
      //   this.starratingSelected,
      //   starRatings,
      //   this.range
      // );
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        location_ids: location_ids,
        business_unit_ids: business_unit_ids,
        partner_ids: partner_ids,
        starRatings: starRatings,
        create_date: create_date,
        page_ref: "location",
      };
      await store.dispatch("get7dayscomments", payload).then(() => {
        // console.log(
        //   "avgRating get7dayscomments::: ",
        //   store.getters.get7dayscomments
        // );
        var avgComments = store.getters.get7dayscomments;

        this.widget_comment = avgComments;
        this.widget_comment_partner = avgComments;
        this.get7daysPrevWeekcomments();
        this.getFrescuraComments();
        return;
      });
    },
    async get7daysPrevWeekcomments() {
      var widget_comments = 0;
      // var partner_ids = this.partner_ids;
      var avgComments = 0;
      var partner_ids = [];
      var business_unit_ids = [];
      var location_ids = [];
      var starRatings = [];
      var create_date = [];

      var partner_ids = this.partner_ids;

      if (this.locationSelected.length > 0) {
        this.locationSelected.forEach((location) => {
          location_ids.push(location);
        });
      }
      // console.log(
      //   "this.locationSelected , location_ids ::: ",
      //   this.locationSelected,
      //   location_ids
      // );
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      // console.log(
      //   "selected ==>",
      //   this.starratingSelected,
      //   starRatings,
      //   this.range
      // );
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        location_ids: location_ids,
        business_unit_ids: business_unit_ids,
        partner_ids: partner_ids,
        starRatings: starRatings,
        create_date: create_date,
        page_ref: "location",
      };
      await store.dispatch("get7daysPrevWeekcomments", payload).then(() => {
        // console.log(
        //   "avgRating get7dayscomments::: ",
        //   store.getters.get7dayscomments
        // );
        var avgComments = store.getters.get7daysPrevWeekcomments;

        this.widget_comment_per = (
          ((this.widget_comment - avgComments) * 100) /
          avgComments
        ).toFixed(2);
        return;
      });
    },
    async getreviewsandcommentgraphdata() {
      var partner_ids = [];
      var business_unit_ids = [];
      var location_ids = [];
      var starRatings = [];
      var create_date = [];

      var partner_ids = this.partner_ids;

      if (this.locationSelected.length > 0) {
        this.locationSelected.forEach((location) => {
          location_ids.push(location);
        });
      }
      // console.log(
      //   "this.locationSelected , location_ids ::: ",
      //   this.locationSelected,
      //   location_ids
      // );
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      // console.log(
      //   "selected ==>",
      //   this.starratingSelected,
      //   starRatings,
      //   this.range
      // );
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        location_ids: location_ids,
        business_unit_ids: business_unit_ids,
        partner_ids: partner_ids,
        starRatings: starRatings,
        create_date: create_date,
        page_ref: "location",
      };
      this.loader_starcommentreview = true;
      await store
        .dispatch("getreviewsandcommentgraphdata", payload)
        .then(() => {
          var reviewsandcommentgraphdata =
            store.getters.getreviewsandcommentgraphdata;
          // console.log(
          //   "reviewsandcommentgraphdata::: ",
          //   reviewsandcommentgraphdata
          // );

          var count = 0;
          var starRating = [];
          var reviews = [];
          var comment = [];
          var comment_count = 0;
          var reviewsandcomment = [];
          this.reviewsandcommentgraphdata_partner = reviewsandcommentgraphdata;
          if (reviewsandcommentgraphdata.length > 0) {
            this.getreview_Count(reviewsandcommentgraphdata);
            this.apex_dataConfig1(reviewsandcommentgraphdata);
          } else {
            this.rating_count = [];
          }
          this.loader_starcommentreview = false;
          return;
        });
    },
    async getstarratingpiechartdata() {
      var partner_ids = [];
      var business_unit_ids = [];
      var location_ids = [];
      var starRatings = [];
      var create_date = [];

      var partner_ids = this.partner_ids;

      if (this.locationSelected.length > 0) {
        this.locationSelected.forEach((location) => {
          location_ids.push(location);
        });
      }
      // console.log(
      //   "this.locationSelected , location_ids ::: ",
      //   this.locationSelected,
      //   location_ids
      // );
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      // console.log(
      //   "selected ==>",
      //   this.starratingSelected,
      //   starRatings,
      //   this.range
      // );
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        location_ids: location_ids,
        business_unit_ids: business_unit_ids,
        partner_ids: partner_ids,
        starRatings: starRatings,
        create_date: create_date,
        page_ref: "location",
      };
      this.loader_starcommentreview = true;

      await store.dispatch("getstarratingpiechartdata", payload).then(() => {
        var starratingpiechartdata = store.getters.getstarratingpiechartdata;
        // console.log("starratingpiechartdata::: ", starratingpiechartdata);
        var count = 0;
        this.starratingpiechartdata_partner = starratingpiechartdata;
        if (starratingpiechartdata.length > 0) {
          this.getstarrating_Count(starratingpiechartdata);
        } else {
          this.rating_count_piechart = [];
        }
        this.loader_starcommentreview = false;

        return;
      });
    },
    async getcommenttabledata() {
      var partner_ids = [];
      var business_unit_ids = [];
      var location_ids = [];
      var starRatings = [];
      var create_date = [];

      var partner_ids = this.partner_ids;

      if (this.locationSelected.length > 0) {
        this.locationSelected.forEach((location) => {
          location_ids.push(location);
        });
      }
      // console.log(
      //   "this.locationSelected , location_ids ::: ",
      //   this.locationSelected,
      //   location_ids
      // );
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      // console.log(
      //   "selected ==>",
      //   this.starratingSelected,
      //   starRatings,
      //   this.range
      // );
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        location_ids: location_ids,
        business_unit_ids: business_unit_ids,
        partner_ids: partner_ids,
        starRatings: starRatings,
        create_date: create_date,
        page_ref: "location",
        offset: this.offset_insight,
      };
      this.loader_commenttable_data = true;
      await store.dispatch("getcommenttabledata", payload).then(() => {
        var commenttabledata = store.getters.getcommenttabledata;
        // console.log("commenttabledata::: ", commenttabledata);
        var count = 0;
        // this.getstarrating_Count(starratingpiechartdata);
        // this.commenttable_data = commenttabledata;
        // this.commenttable_data_partner = commenttabledata;
        if (commenttabledata.length > 0) {
          this.commenttable_data = [
            ...this.commenttable_data,
            ...commenttabledata,
          ];
          this.commenttable_data_partner = [
            ...this.commenttable_data_partner,
            ...commenttabledata,
          ];

          this.offset_insight += commenttabledata.length;
          var aa = commenttabledata.length - this.offset_insight;
          // console.log(
          //   "this.offset_location",
          //   aa,
          //   this.offset_insight,
          //   commenttabledata.length
          // );
          if (aa == 0) {
            this.loadMore = false;
          } else {
            this.loadMore = true;
          }
        } else {
          this.commenttable_data = [];
          this.commenttable_data_partner = [];
        }
        this.loader_commenttable_data = false;
        return;
      });
    },
    async getreviewsvscommentovertime() {
      var partner_ids = [];
      var business_unit_ids = [];
      var location_ids = [];
      var starRatings = [];
      var create_date = [];

      var partner_ids = this.partner_ids;

      if (this.locationSelected.length > 0) {
        this.locationSelected.forEach((location) => {
          location_ids.push(location);
        });
      }
      // console.log(
      //   "this.locationSelected , location_ids ::: ",
      //   this.locationSelected,
      //   location_ids
      // );
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      // console.log(
      //   "selected ==>",
      //   this.starratingSelected,
      //   starRatings,
      //   this.range
      // );
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        location_ids: location_ids,
        business_unit_ids: business_unit_ids,
        partner_ids: partner_ids,
        starRatings: starRatings,
        create_date: create_date,
        page_ref: "location",
      };
      this.loader_reviewsvscommentovertimedata = true;
      await store.dispatch("getreviewsvscommentovertime", payload).then(() => {
        var reviewsvscommentovertimedata =
          store.getters.getreviewsvscommentovertime;
        // console.log(
        //   "reviewsvscommentovertimedata::: ",
        //   reviewsvscommentovertimedata
        // );
        var count = 0;
        this.reviewsvscommentovertimedata_partner =
          reviewsvscommentovertimedata;

        if (reviewsvscommentovertimedata.length > 0) {
          this.getreviewsvscommentovertimedataMonth(
            reviewsvscommentovertimedata
          );
        } else {
          this.loader_reviewsvscommentovertimedata = false;
        }
      });
    },
    async getavgstarratingperday() {
      var partner_ids = [];
      var business_unit_ids = [];
      var location_ids = [];
      var starRatings = [];
      var create_date = [];

      var partner_ids = this.partner_ids;

      if (this.locationSelected.length > 0) {
        this.locationSelected.forEach((location) => {
          location_ids.push(location);
        });
      }
      // console.log(
      //   "this.locationSelected , location_ids ::: ",
      //   this.locationSelected,
      //   location_ids
      // );
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      // console.log(
      //   "selected ==>",
      //   this.starratingSelected,
      //   starRatings,
      //   this.range
      // );
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        location_ids: location_ids,
        business_unit_ids: business_unit_ids,
        partner_ids: partner_ids,
        starRatings: starRatings,
        create_date: create_date,
        page_ref: "location",
      };
      this.loader_avgstarday = true;
      await store.dispatch("getavgstarratingperday", payload).then(() => {
        var avgstarratingperday = store.getters.getavgstarratingperday;
        // console.log("avgstarratingperday::: ", avgstarratingperday);
        var count = 0;
        this.avgstarratingperday_partner = avgstarratingperday;

        if (avgstarratingperday.length > 0) {
          // this.getreviewsvscommentovertimedataMonth(avgstarratingperday);
          this.getreview_Countquarter(avgstarratingperday);
        } else {
        }
        this.loader_avgstarday = false;
        return;
      });
    },
    async getavgstarratingpermonth() {
      var partner_ids = [];
      var business_unit_ids = [];
      var location_ids = [];
      var starRatings = [];
      var create_date = [];

      var partner_ids = this.partner_ids;

      if (this.locationSelected.length > 0) {
        this.locationSelected.forEach((location) => {
          location_ids.push(location);
        });
      }
      // console.log(
      //   "this.locationSelected , location_ids ::: ",
      //   this.locationSelected,
      //   location_ids
      // );
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      // console.log(
      //   "selected ==>",
      //   this.starratingSelected,
      //   starRatings,
      //   this.range
      // );
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        location_ids: location_ids,
        business_unit_ids: business_unit_ids,
        partner_ids: partner_ids,
        starRatings: starRatings,
        create_date: create_date,
        page_ref: "location",
      };
      this.loader_avgstarmonth = true;
      await store.dispatch("getavgstarratingpermonth", payload).then(() => {
        var avgstarratingpermonth = store.getters.getavgstarratingpermonth;
        // console.log("avgstarratingpermonth::: ", avgstarratingpermonth);
        var count = 0;
        this.avgstarratingpermonth_partner = avgstarratingpermonth;
        if (avgstarratingpermonth.length > 0) {
          // this.getreviewsvscommentovertimedataMonth(avgstarratingperday);
          this.getreview_CountMonth(avgstarratingpermonth);
        } else {
          this.loader_avgstarmonth = false;
          return;
        }
      });
    },

    /*for partner api*/
    /*for location api*/
    async get7daysavgRatingbyLocation() {
      var location_ids = this.locationSelected;

      var starRatings = [];
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      // console.log(
      //   "selected ==>",
      //   this.starratingSelected,
      //   starRatings,
      //   this.range
      // );
      var create_date = [];
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
      };

      await store.dispatch("get7daysavgRatingbyLocation", payload).then(() => {
        var avgRating_location = store.getters.get7daysavgRatingbyLocation;
        // console.log(
        //   "avgRating_location get7daysavgRating::: ",
        //   avgRating_location
        // );
        var review_count = 0;
        var starRating = 0;
        var count = 0;
        if (avgRating_location.length > 0) {
          avgRating_location.forEach((reviews) => {
            // console.log("reviews in 7 days avg::::", reviews);
            count = count + 1;
            review_count = review_count + reviews.__count;
            starRating = starRating + reviews.starRating_avg;
          });
          this.widget_rating = (starRating / count).toFixed(2);
          this.widget_rating_location = (starRating / count).toFixed(2);
          this.widget_review = review_count;
          this.widget_review_location = review_count;
        } else {
          this.widget_rating = 0;
          this.widget_review = 0;
          this.widget_rating_location = 0;
          this.widget_review_location = 0;
        }
        return;
      });
    },
    async get7monthsavgRatingbyLocation() {
      var location_ids = this.locationSelected;

      var starRatings = [];
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      // console.log(
      //   "selected ==>",
      //   this.starratingSelected,
      //   starRatings,
      //   this.range
      // );
      var create_date = [];
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
      };
      await store
        .dispatch("get7monthsavgRatingbyLocation", payload)
        .then(() => {
          var monthavgRating_location =
            store.getters.get7monthsavgRatingbyLocation;
          // console.log("monthavgRating get7daysavgRating::: ", monthavgRating);
          var review_count = 0;
          var starRating = 0;
          var count = 0;
          if (monthavgRating_location.length > 0) {
            monthavgRating_location.forEach((reviews) => {
              // console.log("reviews in 7 days avg::::", reviews);
              count = count + 1;
              // review_count = review_count + reviews.__count;
              starRating = starRating + reviews.starRating_avg;
            });
            this.widget_month_rating = (starRating / count).toFixed(2);
          } else {
            this.widget_month_rating = 0;
          }
          return;
        });
    },
    async get7dayscommentsbyLocation() {
      var location_ids = this.locationSelected;
      var starRatings = [];
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      // console.log(
      //   "selected ==>",
      //   this.starratingSelected,
      //   starRatings,
      //   this.range
      // );
      var create_date = [];
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
      };

      var avgComments_location = 0;
      await store.dispatch("get7dayscommentsbyLocation", payload).then(() => {
        var avgComments_location = store.getters.get7dayscommentsbyLocation;
        // console.log("avgRating get7dayscomments::: ", avgComments);

        this.widget_comment_location = avgComments_location;
        return;
      });
    },
    async getreviewsandcommentgraphdatabyLocation() {
      var location_ids = this.locationSelected;

      var starRatings = [];
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      // console.log(
      //   "selected ==>",
      //   this.starratingSelected,
      //   starRatings,
      //   this.range
      // );
      var create_date = [];
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }
      // console.log("create_date in line 1839::: ", create_date);

      var payload = {
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
      };
      await store
        .dispatch("getreviewsandcommentgraphdatabyLocation", payload)
        .then(() => {
          var reviewsandcommentgraphdata_location =
            store.getters.getreviewsandcommentgraphdatabyLocation;
          // console.log(
          //   "reviewsandcommentgraphdata_location::: ",
          //   reviewsandcommentgraphdata_location
          // );
          var count = 0;
          var starRating = [];
          var reviews = [];
          var comment = [];
          var comment_count = 0;
          var reviewsandcomment = [];
          if (reviewsandcommentgraphdata_location.length > 0) {
            this.getreview_Count(reviewsandcommentgraphdata_location);
            this.apex_dataConfig1(reviewsandcommentgraphdata_location);
          }
          return;
        });
    },
    async getstarratingpiechartdatabyLocation() {
      var location_ids = this.locationSelected;
      var starRatings = [];
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      // console.log(
      //   "selected ==>",
      //   this.starratingSelected,
      //   starRatings,
      //   this.range
      // );
      var create_date = [];
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
      };
      await store
        .dispatch("getstarratingpiechartdatabyLocation", payload)
        .then(() => {
          var starratingpiechartdata_location =
            store.getters.getstarratingpiechartdatabyLocation;
          // console.log(
          //   "starratingpiechartdata_location::: ",
          //   starratingpiechartdata_location
          // );
          var count = 0;
          if (starratingpiechartdata_location.length > 0) {
            this.getstarrating_Count(starratingpiechartdata_location);
          }
          return;
        });
    },
    async getcommenttabledatabyLocation() {
      var location_ids = this.locationSelected;
      var starRatings = [];
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      // console.log(
      //   "selected ==>",
      //   this.starratingSelected,
      //   starRatings,
      //   this.range
      // );
      var create_date = [];
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
      };
      await store
        .dispatch("getcommenttabledatabyLocation", payload)
        .then(() => {
          var commenttabledata_location =
            store.getters.getcommenttabledatabyLocation;
          // console.log(
          //   "commenttabledata_location::: ",
          //   commenttabledata_location
          // );
          var count = 0;
          if (commenttabledata_location.length > 0) {
            // this.getstarrating_Count(starratingpiechartdata);
            this.commenttable_data_location = commenttabledata_location;
          }
          return;
        });
    },
    async getreviewsvscommentovertimebyLocation() {
      var location_ids = this.locationSelected;
      var starRatings = [];
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      // console.log(
      //   "selected ==>",
      //   this.starratingSelected,
      //   starRatings,
      //   this.range
      // );
      var create_date = [];
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
      };
      await store
        .dispatch("getreviewsvscommentovertimebyLocation", payload)
        .then(() => {
          var reviewsvscommentovertimedata_location =
            store.getters.getreviewsvscommentovertimebyLocation;
          // console.log(
          //   "reviewsvscommentovertimedata_location::: ",
          //   reviewsvscommentovertimedata_location
          // );
          var count = 0;
          if (reviewsvscommentovertimedata_location.length > 0) {
            this.getreviewsvscommentovertimedataMonth(
              reviewsvscommentovertimedata_location
            );
          }
          return;
        });
    },
    async getavgstarratingperdaybyLocation() {
      var location_ids = this.locationSelected;
      var starRatings = [];
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      // console.log(
      //   "selected ==>",
      //   this.starratingSelected,
      //   starRatings,
      //   this.range
      // );
      var create_date = [];
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
      };
      await store
        .dispatch("getavgstarratingperdaybyLocation", payload)
        .then(() => {
          var avgstarratingperday_location =
            store.getters.getavgstarratingperdaybyLocation;
          // console.log(
          //   "avgstarratingperday_location::: ",
          //   avgstarratingperday_location
          // );
          var count = 0;
          if (avgstarratingperday_location.length > 0) {
            // this.getreviewsvscommentovertimedataMonth(avgstarratingperday);
            this.getreview_Countquarter(avgstarratingperday_location);
          }
          return;
        });
    },
    async getavgstarratingpermonthbyLocation() {
      var location_ids = this.locationSelected;
      var starRatings = [];
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      // console.log(
      //   "selected ==>",
      //   this.starratingSelected,
      //   starRatings,
      //   this.range
      // );
      var create_date = [];
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
      };
      await store
        .dispatch("getavgstarratingpermonthbyLocation", payload)
        .then(() => {
          var avgstarratingpermonth_location =
            store.getters.getavgstarratingpermonthbyLocation;
          // console.log(
          //   "avgstarratingpermonth_location::: ",
          //   avgstarratingpermonth_location
          // );
          var count = 0;
          if (avgstarratingpermonth_location.length > 0) {
            // this.getreviewsvscommentovertimedataMonth(avgstarratingperday);
            this.getreview_CountMonth(avgstarratingpermonth_location);
          }
          return;
        });
    },

    /*for location api*/
    apex_dataConfig(result_monthdata) {
      var average_rating = [];
      var month_data = this.apexdata_label;
      var resultlength = result_monthdata.length;
      if (resultlength > 0) {
        month_data.forEach((month, index) => {
          result_monthdata.forEach((t) => {
            if (month_data[index] == t["createTime:month"]) {
              average_rating[index] =
                t.sum_rating === 0 ? 0 : t.sum_rating / t.count;
            }
          });
        });
      } else {
        // console.log("No data");
      }
      average_rating = average_rating.reduce((result, item) => {
        return result.concat(parseFloat(item.toFixed(2)));
      }, []);
      let avgRatingPercentArr = [];
      avgRatingPercentArr = average_rating.map((item, i) => {
        return i > 0
          ? parseFloat(
              (
                ((item - average_rating[i - 1]) * 100) /
                average_rating[i - 1]
              ).toFixed(2)
            )
          : 0;
      });
      // console.log("info-", avgRatingPercentArr);
      this.loader_avgstarmonth = false;
      this.barChartRightOptionsXaxisDataPoint = this.apexdata_label;
      this.barChartRightOptionsDataColumns = average_rating;
      this.barChartRightOptionsPercentColumns = avgRatingPercentArr;
    },
    apex_dataConfig1(review_data) {
      // let data = {
      //   ratings: [],
      //   comments: [],
      //   reviews: [],
      // };
      // for (let i = 0; i < 5; i++) {
      //   data.ratings.push(this.valueData[i].rating.toString());
      //   data.comments.push(this.valueData[i].comments.toString());
      //   data.reviews.push(this.valueData[i].reviews.toString());
      // }
      var data1 = this.rating_count;
      // console.log("data1:::::::::::", data1);
      var ratings = [];
      var comment_count = [];
      var review_count = [];
      data1.forEach((t) => {
        // console.log("t:::::::::::", t);
        ratings.push(t.starRating);
        comment_count.push(t.comment_count);
        review_count.push(t.review_count);
      });
      // console.log("rating, comment_count, review_count",ratings, comment_count, review_count);
    },
    apex_dataConfig2(result_monthdata) {
      let data = {
        time: [],
        comments: [],
        reviews: [],
      };
      // var comment_count = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      // var review_count = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      var comment_count = [];
      var review_count = [];
      var month_data = this.apexdata_label;
      let monthCount = 0;

      month_data.forEach((month, index) => {
        result_monthdata.forEach((t) => {
          if (month_data[index] == t.month) {
            comment_count[index] = t.comment_count;
            review_count[index] = t.review_count;
            monthCount++;
          }
        });
      });
      // Total Reviews
      const totRevies = review_count.reduce((total, item) => {
        return total + (item - 0);
      }, 0);
      // Total Comments
      const totComments = comment_count.reduce((total, item) => {
        return total + (item - 0);
      }, 0);

      const reviesPercentArr = review_count.reduce((total, item) => {
        return total.concat(parseFloat(((item * 100) / totRevies).toFixed(2)));
      }, []);

      const commentsPercentArr = comment_count.reduce((total, item) => {
        return total.concat(
          parseFloat(((item * 100) / totComments).toFixed(2))
        );
      }, []);

      let nCommentBynReview = [];
      nCommentBynReview = comment_count.map((item, index) => {
        return parseFloat((item / review_count[index]).toFixed(2));
      });

      this.ChartReviewVsCommentOptionsReviewColumn = review_count;
      this.ChartReviewVsCommentOptionsCommentColumn = comment_count;
      this.ChartReviewVsCommentOptionsXaxisDataPoint = this.apexdata_label;
      // this.ChartReviewVsCommentOptionsReviewPercent = reviesPercentArr;
      // this.ChartReviewVsCommentOptionsCommentPercent = nCommentBynReview;
      this.ChartReviewVsCommentOptionsReviewPercent = nCommentBynReview;
      this.loader_reviewsvscommentovertimedata = false;
    },
    apexdata3(result_monthdata) {
      var average_rating = [];
      var days_data = this.apexdata_label_days;
      days_data.forEach((day) => {
        average_rating.push(0);
      });//getreview_Count
      // console.log("days_data", days_data, result_monthdata);

      days_data.forEach((day, index) => {
        result_monthdata.forEach((t) => {
          // console.log("t ::::::::::::::: ", t);
          if (days_data[index] == t["createTime:day"]) {
            // comment_count.push(t.comment_count);
            // review_count.push(t.review_count);
            // average_rating.push(t.sum_rating ===0 ? 0 :(t.sum_rating/t.review_count));
            average_rating[index] =
              t.sum_rating === 0 ? 0 : t.sum_rating / t.count;
          }
        });
      });
      // console.log("this.apexdata_label_days :: ", this.apexdata_label_days);
      // console.log("average_rating :: ", average_rating);

      average_rating = average_rating.reduce((result, item) => {
        return result.concat(parseFloat(item.toFixed(2)));
      }, []);
      let avgRatingPercentArr = [];
      avgRatingPercentArr = average_rating.map((item, i) => {
        return i > 0
          ? parseFloat(
              (
                ((item - average_rating[i - 1]) * 100) /
                average_rating[i - 1]
              ).toFixed(2)
            )
          : 0;
      });
      // console.log("info-", avgRatingPercentArr);
      this.loader_avgstarday = false;
      this.barChartLeftOptionsXaxisDataPoint = this.apexdata_label_days;
      this.barChartLeftOptionsDataColumns = average_rating;
      this.barChartLeftOptionsPercentColumns = avgRatingPercentArr;
    },
    color(value) {
      let $color;
      if (value <= 25) {
        $color = "info";
      } else if (value > 25 && value <= 50) {
        $color = "success";
      } else if (value > 50 && value <= 75) {
        $color = "warning";
      } else if (value > 75 && value <= 100) {
        $color = "danger";
      }
      return $color;
    },
    getAverageRating(reviews) {
      var rating = 0;
      reviews.forEach((r) => {
        rating += r.starRating;
      });
      return rating / reviews.length;
    },
    async getGbaReviews() {
      var array = [];
      // for (let index = 0; index < 5; index++) {
      //   this.valueData.push({
      //     rating: index + 1,
      //     reviews: 0,
      //     comments: 0,
      //     createTime: [],
      //     locationId: [],
      //   });
      // }
      var gbareview = []; //store.getters.getGbaReviews;
      // this.global_gbaReviews = gbareview;
      // if (gbareview.length == 0) {
      this.isLoading = true;
      var partner_ids = this.partner_ids;
      store.dispatch("getGbaReviews", partner_ids).then(() => {
        gbareview = store.getters.getGbaReviews;
        // console.log("gbareview ::::::::::::: ", gbareview);
        this.global_gbaReviews = gbareview;
        this.global_gbaReviewsArray = gbareview;
        this.getreview_Countweek(gbareview);
        this.getreview_Count_month(gbareview);
        this.getreview_Count(gbareview);
        this.apex_dataConfig1(gbareview);
        this.getreview_CountMonth(gbareview);
        this.getreview_Countquarter(gbareview);
        // shuffleArray([gbareview]);
        this.isLoading = false;
      });
      // } else {
      //   this.isLoading = false;
      //   var reviewdata = [];
      //   var commentdata = [];

      //   let yearlyReviews = [];
      //   let years = [];
      //   this.global_gbaReviewsArray = gbareview;
      //   this.getreview_Countweek(gbareview);
      //   this.getreview_Count_month(gbareview);

      //   this.getreview_Count(gbareview);
      //   this.apex_dataConfig1(gbareview);
      //   this.getreview_CountMonth(gbareview);
      //   this.getreview_Countquarter(gbareview);
      // }
      // this.tempValueData = this.valueData;
      // this.barchartdata1();
    },
    getuniqueRatings(starRatings) {
      // console.log("getuniqueRatings", starRatings);
      var unique_rating = [];
      starRatings.forEach((rating) => {
        unique_rating.push({
          label: rating.starRating,
          value: rating.starRating,
        });
      });
      // console.log("unique_rating::::::::", unique_rating);
      this.starRating_unique = unique_rating;

      // this.starRatings = _.sortBy( starRatingunique, 'name' );
    },
    getreview_Count(review_data) {
      var count = 0;
      var prev_key = "";
      var sorted_review = _.sortBy(review_data, "starRating");
      // console.log("sorted_review:::::::;", gbareview, sorted_review);
      let result_star_rating = [
        ...sorted_review
          .reduce((r, o) => {
            const key = o.starRating;
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                review_count: 0,
                comment_count: 0,
              });
            // console.log("info-", key, r, o);
            // //console.log("key in score::::::::", key);
            // if(key !== false){
            if (prev_key !== key) {
              if (o.has_comment !== false) item.comment_count += o.__count;
              item.review_count += o.__count;
              prev_key = key;
            } else {
              if (o.comment !== false) item.comment_count += o.__count;
              item.review_count += o.__count;
            }

            return r.set(key, item);
          }, new Map())
          .values(),
      ];

      // Total Rating
      const totRatings = result_star_rating.reduce((total, item) => {
        return total + (item.review_count - 0);
      }, 0);
      // Total Comments
      const totComments = result_star_rating.reduce((total, item) => {
        return total + (item.comment_count - 0);
      }, 0);
      let resultStarRating = [];
      this.widget_perception_per = parseFloat((totComments / totRatings)*100).toFixed(
        2
      );

      resultStarRating = result_star_rating.map((object) => ({
        ...object,
        avg_review: totRatings
          ? parseFloat(((object.review_count * 100) / totRatings).toFixed(2))
          : 0,
        avg_comment: totComments
          ? parseFloat(((object.comment_count * 100) / totComments).toFixed(2))
          : 0,
        participation: parseFloat(
          (object.comment_count / object.review_count).toFixed(2)
        ),
      }));
      result_star_rating = resultStarRating;
      // console.log("info-", totRatings, totComments, result_star_rating);

      let graphReviewColumn = result_star_rating.reduce((result, item) => {
        return result.concat(item.review_count);
      }, []);
      let graphCommentColumn = result_star_rating.reduce((result, item) => {
        return result.concat(item.comment_count);
      }, []);
      let graphReviewPercent = result_star_rating.reduce((result, item) => {
        return result.concat(item.avg_review);
      }, []);
      let graphCommentPercent = result_star_rating.reduce((result, item) => {
        return result.concat(item.avg_comment);
      }, []);
      let nCommentBynReview = result_star_rating.reduce((result, item) => {
        return result.concat(item.participation);
      }, []);

      this.graphReviewColumn = graphReviewColumn;
      this.graphCommentColumn = graphCommentColumn;
      // this.graphReviewPercent = graphReviewPercent;
      // this.graphCommentPercent = nCommentBynReview;
      this.graphReviewPercent = nCommentBynReview;

      // this.chartOptionsSpline.series[0] = {
      //   ...this.chartOptionsSpline.series[0],
      //   data: [...graphReviewColumn],
      // };
      // this.chartOptionsSpline.series[1].data = graphCommentColumn;

      // this.topic_starrating_data=result_star_rating;
      // var result_star_rating1=[]
      // result_star_rating.forEach((rating)=>{
      //   if(rating.category_name !== false)
      //     result_star_rating1.push(rating);
      // })
      this.rating_count = result_star_rating;
      this.getuniqueRatings(result_star_rating);
      // console.log("rating_count", this.rating_count);
      return;
    },

    getstarrating_Count(review_data) {
      var count = 0;
      var prev_key = "";
      var sorted_review = _.sortBy(review_data, "starRating");
      // console.log("sorted_review:::::::;", gbareview, sorted_review);
      const result_star_rating = [
        ...sorted_review
          .reduce((r, o) => {
            const key = o.starRating;
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                review_count: 0,
                comment_count: 0,
              });
            // console.log("key in score::::::::", key);
            // if(key !== false){
            if (prev_key !== key) {
              if (o.has_comment !== false) item.comment_count += o.__count;
              item.review_count += o.__count;
              prev_key = key;
            } else {
              if (o.comment !== false) item.comment_count += o.__count;
              item.review_count += o.__count;
            }

            return r.set(key, item);
          }, new Map())
          .values(),
      ];

      // this.topic_starrating_data=result_star_rating;
      // var result_star_rating1=[]
      // result_star_rating.forEach((rating)=>{
      //   if(rating.category_name !== false)
      //     result_star_rating1.push(rating);
      // })
      this.rating_count_piechart = result_star_rating;
      // this.getuniqueRatings(result_star_rating);
      // console.log("rating_count", this.rating_count);
      return;
    },
    getreviewsvscommentovertimedataMonth(reviewsvscommentovertimedata) {
      var prev_key = "";
      var months = [];
      const result_monthdata = [
        ...reviewsvscommentovertimedata
          .reduce((r, o) => {
            const key = o["createTime:month"];
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                comment_count: 0,
                review_count: 0,
                month: "",
              });
            if (prev_key !== key) {
              if (o.has_comment !== false) item.comment_count += o.__count;
              item.review_count += o.__count;

              prev_key = key;
              item.month = o["createTime:month"];
              months.push(o["createTime:month"]);
              // console.log("key, item 1111::::::::", o["create_date:month"]);
            } else {
              if (o.has_comment !== false) item.comment_count += o.__count;
              item.review_count += o.__count;
            }

            return r.set(key, item);
          }, new Map())
          .values(),
      ];
      // console.log("result_monthdata 1111::::: ", months, result_monthdata);

      this.apexdata_label = months;
      this.apex_dataConfig2(result_monthdata);
      // this.apex_dataConfig(result_monthdata);

      return;
    },
    getreview_CountMonth(gbareview) {
      // console.log("gbareview in getreview_CountMonth ::::", gbareview);
      // var endDate =
      //   typeof this.range !== "string" && this.range[1] !== null
      //     ? moment(this.range[1]).format("DD MMM YYYY")
      //     : moment().endOf("month").format("DD MMM YYYY");
      // var startDate =
      //   typeof this.range !== "string" && this.range[0] !== null
      //     ? moment(this.range[0]).format("DD MMM YYYY")
      //     : moment()
      //         .subtract(1, "year")
      //         .add(1, "month")
      //         .startOf("month")
      //         .format("DD MMM YYYY");
      // var months = [];
      // var currentDate = startDate;
      // while (moment(currentDate) < moment(endDate)) {
      //   months.push(moment(currentDate).format("MMM YYYY"));
      //   currentDate = moment(currentDate).add(1, "month").format("DD MMM YYYY");
      // }

      // var gbareview_sorted = _.sortBy(gbareview, "createTime");
      // var filtered_data = gbareview_sorted.filter((item) => {
      //   return (
      //     moment(item.createTime) >= moment(startDate) &&
      //     moment(item.createTime) < moment(endDate)
      //   );
      // });
      var months = [];
      var prev_key = "";
      const result_monthdata = [
        ...gbareview
          .reduce((r, o) => {
            const key = o["createTime:month"];
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                comment_count: 0,
                review_count: 0,
                sum_rating: 0,
                month: "",
                count: 0,
              });
            if (prev_key !== key) {
              if (o.starRating_avg !== 0)
                item.sum_rating = item.sum_rating + o.starRating_avg;
              prev_key = key;
              item.month = o["createTime:month"];
              months.push(o["createTime:month"]);
              item.count += 1;
            } else {
              item.sum_rating = item.sum_rating + o.starRating_avg;
              item.count += 1;
            }

            return r.set(key, item);
          }, new Map())
          .values(),
      ];
      // console.log("result_monthdata 1111::::: ", months ,result_monthdata);

      this.apexdata_label = months;
      // this.apex_dataConfig2(result_monthdata);
      this.apex_dataConfig(result_monthdata);

      return;
    },
    getreview_Countquarter(gbareview) {
      var days = [];
      var prev_key = "";
      const result_monthdata = [
        ...gbareview
          .reduce((r, o) => {
            const key = o["createTime:day"];
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                review_count: 0,
                sum_rating: 0,
                day: "",
                count: 0,
              });
            //console.log("key in score::::::::", key, o.starRating_avg , o);
            if (prev_key !== key) {
              item.review_count += item.review_count + o.__count;
              if (o.starRating !== 0) item.sum_rating += o.starRating_avg;
              prev_key = key;
              item.day = o["createTime:day"];
              days.push(o["createTime:day"]);
              item.count += 1;
            } else {
              item.count += 1;
              item.review_count += item.review_count + o.__count;
              if (o.starRating !== 0) item.sum_rating += o.starRating_avg;
            }

            return r.set(key, item);
          }, new Map())
          .values(),
      ];

      this.apexdata_label_days = days;
      this.apexdata3(result_monthdata);
      // console.log("result_monthdataaoex3 ::::: " ,result_monthdata);

      return;
    },
    getreview_Countweek(gbareview) {
      // console.log("gbareview in getreview_CountMonth ::::", gbareview);
      var endDate = moment("2020-03-01").format("DD MMM YYYY");
      var startDate = moment("2020-03-01")
        .subtract(7, "days")
        .format("DD MMM YYYY");
      var months = [];
      var currentDate = startDate;

      var gbareview_sorted = _.sortBy(gbareview, "createTime");
      // console.log("gbareview_sorted======== start and end", gbareview_sorted.length, startDate, endDate);
      var filtered_data = gbareview_sorted.filter((item) => {
        return (
          moment(item.createTime) >= moment(startDate) &&
          moment(item.createTime) < moment(endDate)
        );
      });
      // console.log("filtered_data", filtered_data.length);

      var prev_key = "";
      const result_monthdata = [
        ...filtered_data
          .reduce((r, o) => {
            const key = moment(o.createTime).format("DD MMM YYYY");
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                comment_count: 0,
                review_count: 0,
                sum_rating: 0,
                month: "",
              });
            if (prev_key !== key) {
              if (o.comment !== false) item.comment_count += 1;
              item.review_count += 1;
              if (o.starRating !== 0)
                item.sum_rating = item.sum_rating + o.starRating;
              prev_key = key;
              item.month = moment(o.createTime).format("MMM YYYY");
              // console.log("key, @@@item 1111::::::::", item.sum_rating ,item.review_count, key , o.starRating ,item.sum_rating);
            } else if (o.comment !== false) item.comment_count += 1;
            item.review_count += 1;
            if (o.starRating !== 0)
              item.sum_rating = item.sum_rating + o.starRating;

            // console.log("key, item 1111",o.starRating, item.review_count,item.sum_rating, key);//, item, item.month

            return r.set(key, item);
          }, new Map())
          .values(),
      ];
      // console.log("weekdata 1111::::: ",result_monthdata, result_monthdata[0].review_count, result_monthdata[0].comment_count,result_monthdata[0].sum_rating,  result_monthdata[0].sum_rating / result_monthdata[0].review_count);

      this.widget_weekdata = result_monthdata;
      var weekdata_rating = [];
      var weekdata_comment = [];
      var weekdata_reviews = [];
      var sum_rating = 0;
      var sum_reviews = 0;
      var sum_comment = 0;

      result_monthdata.forEach((week) => {
        // console.log("WEeek data:", week);
        sum_rating += week.sum_rating;
        sum_reviews += week.review_count;
        sum_comment += week.comment_count;

        weekdata_rating.push(week.sum_rating);
        weekdata_comment.push(week.comment_count);
        weekdata_reviews.push(week.review_count);
      });
      // console.log("weekdata", weekdata_rating);
      // console.log("weekdata", weekdata_comment);
      // console.log("weekdata_reviews", weekdata_reviews);
      this.widget_weekdata_rating = weekdata_rating;
      this.widget_weekdata_comment = weekdata_comment;
      this.widget_weekdata_review = weekdata_reviews;
      this.widget_reviews = sum_reviews;
      this.widget_comments = sum_comment;
      // console.log("sum_rating , sum_reviews ", sum_rating, sum_reviews);
      if (sum_reviews > 0) {
        this.widget_rating = Number(sum_rating / sum_reviews).toFixed(2);
      } else {
        this.widget_rating = 0;
      }
      return;
    },
    getreview_Count_month(gbareview) {
      // console.log("gbareview in getreview_CountMonth ::::", gbareview);
      var endDate = moment().format("DD MMM YYYY");
      var startDate = moment().subtract(1, "year").format("DD MMM YYYY");
      var months = [];
      var currentDate = startDate;
      while (moment(currentDate) < moment(endDate)) {
        months.push(moment(currentDate).format("MMM YYYY"));
        currentDate = moment(currentDate).add(1, "month").format("DD MMM YYYY");
      }

      var gbareview_sorted = _.sortBy(gbareview, "createTime");
      // console.log("gbareview_sorted=mnth======= start and end", gbareview_sorted.length, startDate, endDate);
      var filtered_data = gbareview_sorted.filter((item) => {
        return (
          moment(item.createTime) >= moment(startDate) &&
          moment(item.createTime) < moment(endDate)
        );
      });
      // console.log("filtered_data mont=======", filtered_data.length);

      var prev_key = "";
      const result_monthdata = [
        ...filtered_data
          .reduce((r, o) => {
            const key = moment(o.createTime).format("MMM YYYY");
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                comment_count: 0,
                review_count: 0,
                sum_rating: 0,
                month: "",
              });
            if (prev_key !== key) {
              if (o.comment !== false) item.comment_count += 1;
              item.review_count += 1;
              if (o.starRating !== 0)
                item.sum_rating = item.sum_rating + o.starRating;
              prev_key = key;
              item.month = moment(o.createTime).format("MMM YYYY");
              // console.log("key, item 1111::::::::", item.sum_rating ,item.review_count, key , o.starRating ,item.sum_rating);
            } else if (o.comment !== false) item.comment_count += 1;
            item.review_count += 1;
            if (o.starRating !== 0)
              item.sum_rating = item.sum_rating + o.starRating;

            // console.log("key, item 1111",o.starRating, item.review_count,item.sum_rating, key);//, item, item.month

            return r.set(key, item);
          }, new Map())
          .values(),
      ];
      // console.log("result_monthdata 222::::: ", months ,result_monthdata);

      this.widget_month_data = result_monthdata;
      var widget_month_data = [];
      var total_review_count = 0;
      var total_rating = 0;
      months.forEach((month, index) => {
        result_monthdata.forEach((t) => {
          // console.log("===========",month,t);
          if (months[index] == t.month) {
            widget_month_data[index] =
              t.sum_rating === 0
                ? 0
                : (t.sum_rating / t.review_count).toFixed(2);
          }
          total_review_count += t.review_count;
          total_rating += t.sum_rating;
          // total_review_count += months.
          // month_data.push(month);
        });
      });

      // console.log("result_monthdata.sum_rating , result_monthdata.review_count", result_monthdata.sum_rating , result_monthdata.review_count);
      this.widget_monthlyRating = (total_rating / total_review_count).toFixed(
        2
      );
      this.widget_month_data = widget_month_data;
      this.labelbar = months;

      return;
    },

    // New API widget end point
    async getFrescuraReviews() {
      var partner_ids = [];
      var business_unit_ids = [];
      var location_ids = [];
      var starRatings = [];
      var create_date = [];
      this.fresturaReviews = 0;

      var partner_ids = this.partner_ids;
      if (this.locationSelected.length > 0) {
        this.locationSelected.forEach((location) => {
          location_ids.push(location);
        });
      }
      //  console.log(
      //   "this.locationSelected , location_ids ::: ",
      //   this.locationSelected,
      //   location_ids
      // );
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      // console.log(
      //   "selected ==>",
      //   this.starratingSelected,
      //   starRatings,
      //   this.range
      // );
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        location_ids: location_ids,
        business_unit_ids: business_unit_ids,
        partner_ids: partner_ids,
        starRatings: starRatings,
        create_date: create_date,
        page_ref: "location",
      };
      this.loader_avgstarmonth = true;
      await store.dispatch("getfrescuraReviews", payload).then(() => {
        var reviews = store.getters.getfrescuraReviews;
        if (reviews) {
          this.fresturaReviews = parseFloat(
            this.widget_rating / reviews
          ).toFixed(4);
        } else {
          this.fresturaReviews = 0;
        }
        // // console.log("avgstarratingpermonth::: ", avgstarratingpermonth);
        // var count = 0;
        // this.avgstarratingpermonth_partner = avgstarratingpermonth;
        // if (avgstarratingpermonth.length > 0) {
        //   // this.getreviewsvscommentovertimedataMonth(avgstarratingperday);
        //   this.getreview_CountMonth(avgstarratingpermonth);
        // } else {
        //   this.loader_avgstarmonth = false;
        //   return;
        // }
      });
    },
    async getFrescuraComments() {
      var partner_ids = [];
      var business_unit_ids = [];
      var location_ids = [];
      var starRatings = [];
      var create_date = [];
      this.fresturaComments = 0;

      var partner_ids = this.partner_ids;
      if (this.locationSelected.length > 0) {
        this.locationSelected.forEach((location) => {
          location_ids.push(location);
        });
      }
      //  console.log(
      //   "this.locationSelected , location_ids ::: ",
      //   this.locationSelected,
      //   location_ids
      // );
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      // console.log(
      //   "selected ==>",
      //   this.starratingSelected,
      //   starRatings,
      //   this.range
      // );
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        location_ids: location_ids,
        business_unit_ids: business_unit_ids,
        partner_ids: partner_ids,
        starRatings: starRatings,
        create_date: create_date,
        page_ref: "location",
      };
      this.loader_avgstarmonth = true;
      await store.dispatch("getfrescuraComments", payload).then(() => {
        var comments = store.getters.getfrescuraComments;
        if (comments) {
          this.fresturaComments = parseFloat(
            this.widget_comment / comments
          ).toFixed(4);
        } else {
          this.fresturaComments = 0;
        }
      });
    },
  },
  watch: {
    partnerSelected: function (partnerSelected) {
      var partner_ids = [];
      // console.log("partner_ids::::", partnerSelected);
      // partnerSelected.forEach((partner) => {
      if (partnerSelected !== null) partner_ids.push(partnerSelected.id);
      // });
      this.locationSelected = [];

      if (partner_ids.length > 0) {
        // partner_ids = partner_ids;
        this.partner_ids = partner_ids;
        this.getlocation();
        this.get7daysavgRating();
        this.get7dayscomments();
        this.get7monthsavgRating();
        this.getreviewsandcommentgraphdata();
        this.getstarratingpiechartdata();
        this.getcommenttabledata();
        this.getreviewsvscommentovertime();
        this.getavgstarratingperday();
        this.getavgstarratingpermonth();

        // this.getlocationbyPartner();
        // this.getGbaReviews();
      } else {
        this.widget_rating = 0;
        this.widget_comment = 0;
        this.widget_review = 0;
        this.widget_month_rating = 0;
        this.rating_count = [];
        this.rating_count_piechart = [];
        this.starRating_unique = [];
        this.commenttable_data = [];
        this.commenttable_data_partner = [];

        this.locations = [];
        this.locations1 = [[]];
        this.locationsArray = [];
        // this.locations1 = [];
        this.gbareview = [];
        // this.locationSelected = "";
      }
    },
    graphReviewColumn: function (newpoints) {
      this.chartOptionsSpline.series[0].data = newpoints;
    },
    graphCommentColumn: function (newpoints) {
      this.chartOptionsSpline.series[1].data = newpoints;
      
    },
    graphReviewPercent: function (newpoints) {
      this.chartOptionsSpline.series[2].data = newpoints;
      
    },
    graphCommentPercent: function (newpoints) {
      this.chartOptionsSpline.series[3].data = newpoints;
    },
    /*graphStarRatingxAxis: function(newpoints){
      this.chartOptionsSpline.xAxis[0].categories= newpoints;
    },*/
    ChartReviewVsCommentOptionsXaxisDataPoint: function (newpoints) {
      this.ChartReviewVsCommentOptions.xAxis[0].categories = newpoints;
    },
    ChartReviewVsCommentOptionsReviewColumn: function (newpoints) {
      this.ChartReviewVsCommentOptions.series[0].data = newpoints;
    },
    ChartReviewVsCommentOptionsCommentColumn: function (newpoints) {
      this.ChartReviewVsCommentOptions.series[1].data = newpoints;
    },
    ChartReviewVsCommentOptionsReviewPercent: function (newpoints) {
      this.ChartReviewVsCommentOptions.series[2].data = newpoints;
    },
    ChartReviewVsCommentOptionsCommentPercent: function (newpoints) {
      this.ChartReviewVsCommentOptions.series[3].data = newpoints;
    },

    barChartRightOptionsXaxisDataPoint: function (newpoints) {
      this.barChartRightOptionsSpline.xAxis[0].categories = newpoints;
    },
    barChartRightOptionsDataColumns: function (newpoints) {
      this.barChartRightOptionsSpline.series[0].data = newpoints;
    },
    barChartRightOptionsPercentColumns: function (newpoints) {
      this.barChartRightOptionsSpline.series[1].data = newpoints;
    },

    barChartLeftOptionsXaxisDataPoint: function (newpoints) {
      this.barChartLeftOptionsSpline.xAxis[0].categories = newpoints;
    },
    barChartLeftOptionsDataColumns: function (newpoints) {
      this.barChartLeftOptionsSpline.series[0].data = newpoints;
    },
    barChartLeftOptionsPercentColumns: function (newpoints) {
      this.barChartLeftOptionsSpline.series[1].data = newpoints;
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.barchart {
  height: 1000;
  width: 1000;
}
.gridstyle .col-md-4 {
  display: grid;
}
.flevelwidget {
  min-height: 160.5px;
}
.p-0 {
  padding: 0px;
}
.card-widget-new {
  flex-direction: row;
  color: #fff;
  align-items: center;
}
.card-widget-new .card-body {
  padding: 0px;
  min-height: 160.5px;
}
.card-widget-new .card-header {
  color: #fff;
  text-align: center;
  font-weight: 700;
  font-size: 0.95rem;
  text-transform: uppercase;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  background: transparent;
  border-bottom: 0;
  border-right: 1px solid #cecece8f;
  min-width: 50%;
}
.card-widget-new.blue {
  background-color: #2d8be0;
}
.card-widget-new.green {
  background-color: #22a849;
}
.card-widget-new.red {
  background-color: #fb963e;
}
.card-widget-new .card-body {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 125px;
  padding-left: 12%;
}
.card-widget-new .card-body h3 {
  font-size: 2rem;
}
.card-widget-new .card-body p {
  font-weight: 600;
}

._widget-div {
  display: flex;
}
._widget-div ._widget-item {
  flex: 1;
  margin: 5px;
  color: #fff;
  padding: 10px;
  min-height: 160.5px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  background: blueviolet;
  justify-content: center;
  margin-bottom: 20px;
}
._item-wrapper {
  display: flex;
  flex-direction: column;
}
._item-wrapper hr {
  background: #ffffff85;
  height: 1px;
  width: 52%;
  margin: 1px auto 5px auto;
}
._item-wrapper h5 {
  font-weight: 600;
}
._item-wrapper p.text-center {
  font-weight: 600;
}

._widget-div ._widget-item:first-child {
  background: #6c6e7e;
}
._widget-div ._widget-item:nth-child(2) {
  background: #6c6e7e;
}
._widget-div ._widget-item:nth-child(3) {
  background: #6c6e7e;
}
._widget-div ._widget-item:nth-child(4) {
  background: #6c6e7e;
}
._widget-div ._widget-item:nth-child(5) {
  background: #6c6e7e;
}
._widget-div ._widget-item:nth-child(6) {
  background: #6c6e7e;
}
._widget-div ._widget-item:nth-child(7) {
  background: #6c6e7e;
}
@media only screen and (max-width: 768px) {
  ._widget-div {
    flex-direction: column;
  }
}
</style>
